export const translations = {
  en: {
    navigation: {
      login: 'Book Call',
      startForFree: 'Start for free',
    },
    countdown: {
      days: 'days',
      hours: 'hours',
      minutes: 'minutes',
      seconds: 'seconds',
      freeStrategyCall: 'FREE Strategy Call',
    },
    breakBar: {
      headline: 'Trusted by',
    },
    heroHeader: {
      tagline: 'Powered by AI. Controlled by You.',
      taglineDesc: 'The revenue system that orchestrates email, LinkedIn & follow-ups into one coordinated engine. It learns from every reply and scales what converts.',
      titlePre: 'Build a',
      titlePost: 'Machine.',
      titleWords: ['Client', 'Sales', 'Lead', 'Revenue', 'Growth', 'Marketing'],
      subtitle: 'BonusClub turns outreach into a structured system, so your pipeline grows predictably instead of by chance.',
      getStarted: 'BOOK STRATEGY CALL',
      freeBadge: 'FREE',
      learnMore: 'See How It Works',
      productsTitle: 'Our Products',
      products: {
        pages: 'PAGES',
        god: 'GOD',
        xraay: 'XRAAY',
      },
    },
    adCostChart: {
      label: 'The Reality',
      title: 'Getting Noticed Is Getting Harder.',
      subtitle: 'Decision-makers are flooded with messages. Most teams send more. Almost none build structure.',
      bars: [
        { year: '2016', ago: '~10 years ago', cpc: '~25 / day', width: '33%', change: 'Baseline' },
        { year: '2021', ago: '~5 years ago', cpc: '~45 / day', width: '58%', change: '+80%' },
        { year: '2025', ago: 'Today', cpc: '70+ / day', width: '92%', change: '+180%' },
      ],
      alert: 'Inboxes are saturated. Without structure, your message disappears in the noise.',
      source: 'Average number of sales messages a B2B decision-maker receives per day. Based on publicly available industry benchmarks.',
    },
    systemHealth: {
      screenTitle: 'system_health.exe',
      indicators: [
        { label: 'Attention', status: 'ok' },
        { label: 'Clicks', status: 'ok' },
        { label: 'Tracking', status: 'critical' },
        { label: 'Intent', status: 'critical' },
        { label: 'Sales Velocity', status: 'critical' },
      ],
      statusOk: 'Online',
      statusCritical: 'Critical',
      verdict1: 'Operational.',
      verdict2: 'Not efficient.',
      footnote: 'You\'re getting traffic. But traffic without intent is just noise.',
    },
    dependencyMeter: {
      label: 'Risk Assessment',
      title: 'You Don\'t Own Your Pipeline.',
      gaugeLabel: 'Channel Dependency',
      risks: ['Platform risk', 'Inconsistent output', 'No real ownership'],
      costsTitle: 'Where your effort actually goes',
      costs: [
        { label: 'Outreach Tools', value: '$500-2k/mo' },
        { label: 'Manual Work', value: '10-20h/wk' },
        { label: 'Content Production', value: '$1k-3k/mo' },
        { label: 'CRM & Tools', value: '$500-2k/mo' },
        { label: 'SDR Salary', value: '$4k-7k/mo' },
        { label: 'Lost Opportunities', value: '????' },
      ],
      footnote: 'If your pipeline disappears the moment you stop, you don\'t have a system. You have a subscription to hope.',
    },
    costReceipt: {
      store: 'Manual Outreach',
      date: 'Q4 2025',
      title: 'This Is What Unstructured Outreach Costs.',
      lines: [
        { label: 'Emails Sent', value: '4,000', bold: false },
        { label: 'Open Rate', value: '38%', bold: false },
        { label: 'Replies', value: '52', bold: false },
        { label: 'Reply Rate', value: '1.3%', bold: false },
        { label: 'Positive Replies', value: '12', bold: false },
        { label: 'Meetings Booked', value: '5', bold: false },
        { label: 'Show-Up Rate', value: '60%', bold: false },
        { label: 'Meetings Held', value: '3', bold: false },
        { label: 'Held → Closed', value: '33%', bold: false },
        { label: 'Closed', value: '1', bold: true },
        { label: 'Hours Invested', value: '90h', bold: true },
      ],
      totalLabel: 'Hours Invested',
      totalValue: '90 hours',
      cpcLabel: 'Time per Customer',
      cpcValue: '90h',
      resultLabel: 'Clients acquired',
      resultValue: '1',
      footer: 'Thank you for your effort. Results may vary. Patience recommended.',
    },
    transitionBreak: {
      line1: 'The problem isn\'t effort.',
      line2: 'It\'s infrastructure.',
    },
    channelNodes: {
      label: 'The Problem',
      titleHighlight: 'Most Teams',
      titleRest: 'Are Flying Blind.',
      description: 'Disconnected tools, no attribution, no real follow-up. This is what outbound looks like without structure.',
      labelAI: 'The Solution',
      titleAIHighlight: 'The System',
      titleAIRest: ' Behind',
      titleAIRest2: 'Predictable Outbound.',
      descriptionAI: 'BonusClub coordinates all your touchpoints, learns from real replies, and helps you scale what works. No chaos. No guesswork.',
      toggleOld: '95% of Businesses',
      toggleNew: 'BonusClub',
      stats: [
        { value: '79%', label: 'Of leads never\nconvert to sales', source: 'HubSpot State of Marketing, 2024' },
        { value: '42d', label: 'Average B2B\ndeal cycle', source: 'Salesforce State of Sales, 2024' },
        { value: '57%', label: 'Of the decision is made\nbefore you\'re contacted', source: 'Gartner, 2025' },
      ],
      painCards: [
        { icon: 'chart', status: 'critical', title: 'No Structure, No Pipeline', text: 'Most teams send more messages instead of building a system. The result: wasted effort, zero predictability.', source: '' },
        { icon: 'clock', status: 'critical', title: 'Deals Die in Silence', text: 'Without structured follow-up, warm leads go cold. Every week without a system costs you real revenue.', source: '' },
      ],
      sources: '',
      aiStats: [
        { value: '27+', label: 'Qualified meetings\nin 90 days*', source: 'Best-case client example, not a guarantee' },
        { value: '9', label: 'New mandates\nper quarter*', source: 'Selected client example, not guaranteed' },
        { value: '24/7', label: 'Always-on\noutreach engine', source: 'Structured sequencing & follow-up' },
      ],
      aiCards: [
        { icon: 'chart', status: 'active', title: 'Qualified Meetings on Your Calendar', text: 'Our system is designed to deliver booked appointments with decision-makers who match your ICP. You just show up and close.' },
        { icon: 'clock', status: 'active', title: 'Structured Follow-Up That Converts', text: 'Multi-channel sequences that stay on top of every lead, so nothing falls through the cracks.' },
      ],
      aiSources: '*These figures reflect selected client examples and are not guaranteed results. Actual outcomes vary significantly by industry, market, setup, and individual effort. Past performance is not indicative of future results.',
      aiPanelLabel: 'bonusclub.engine',
    },
    chaosWall: {
      items: [
        'Cold emails → Spam',
        'Tools that don\'t talk',
        'Algorithm changes',
        '"Let me think about it"',
        'No-shows on calls',
        'Content nobody sees',
        'Vanity metrics',
        'LinkedIn spam',
        '0.3% response rate',
        '"We\'ll circle back"',
        'Unqualified leads',
        'Ghosted after demo',
        'Posting into the void',
        'CRM chaos',
        'Random follow-ups',
        'Effort with no payoff',
        '"Not the right time"',
        'Inconsistent pipeline',
        'Copy-paste outreach',
        'Social media burnout',
        'Chasing algorithms',
        'Endless A/B tests',
        'Lead lists that go nowhere',
        '"Send me more info"',
        'Manual prospecting',
      ],
      line1: 'Sound familiar?',
      title: 'There\'s a better way.',
    },
    processFlow: {
      steps: [
        { label: 'Deep Analysis', title: 'Your Market' },
        { label: 'Structured System', title: 'Built to Scale' },
        { label: 'Predictable Results', title: 'Every Quarter' },
      ],
    },
    problemSection: {
      label: 'The Problem',
      title: 'Growth Feels Random Because It Is.',
      lines: [
        'You run campaigns.',
        'You post content.',
        'You test channels.',
        'You tweak messaging.',
      ],
      highlight: 'Some weeks work. Some don\'t.',
      body: 'That\'s not strategy. That\'s volatility.',
      conclusion: 'If your growth depends on algorithms, mood, or timing, you don\'t own it.',
      closing: 'And what you don\'t control, you can\'t scale.',
    },
    reframeSection: {
      label: 'The Reframe',
      title: 'Acquisition Is Infrastructure.',
      anti: ['Not motivation.', 'Not hacks.', 'Not "more activity."'],
      listTitle: 'Infrastructure means:',
      list: [
        'Clear positioning',
        'Defined ICP',
        'Structured outreach',
        'Measurable volume',
        'Controlled execution',
      ],
      contrast1: 'Campaigns create spikes.',
      contrast2: 'Systems create consistency.',
      bold: 'Hope doesn\'t scale.',
      boldHighlight: 'Structure does.',
    },
    systemSection: {
      label: 'How It Works',
      title: 'From Zero to Qualified Meetings.',
      subtitle: 'A clear, repeatable process, so your pipeline never depends on luck.',
      steps: [
        { number: '01', title: 'We Define Your ICP', text: 'Who are your best-fit clients? We map the exact companies and decision-makers worth reaching.' },
        { number: '02', title: 'We Build the System', text: 'Multi-channel outreach sequences, messaging, technical setup. All done for you.' },
        { number: '03', title: 'We Deliver Meetings', text: 'Qualified, booked appointments with decision-makers land directly on your calendar.' },
        { number: '04', title: 'We Optimize Weekly', text: 'Real data drives every refinement. What works gets scaled. What doesn\'t gets cut.' },
      ],
      closing: 'You focus on closing. We handle the rest.',
      cta: 'Book Strategy Call',
    },
    proofSection: {
      label: 'Proof',
      titleLines: ['Save Time.', 'Starting Day One.'],
      subtitle: 'BonusClub optimizes your communication processes and delivers significant efficiency gains that directly impact your daily business.',
      stats: [
        { value: '~10.5h', unit: '/day', description: 'Hours per day that can potentially be saved when handling an average of 42 personally written emails, thanks to pre-built and personalized content.' },
        { prefix: 'Save', value: '$8,000+', unit: '/month', description: 'Potential monthly cost savings, calculated as an example at $40 internal cost per hour. Actual savings depend on your specific situation.' },
        { value: '= 210h', unit: '/month', description: 'Hours per month of potential time savings that would no longer need to be spent writing, researching, and thinking.' },
      ],
      disclaimer: 'These figures are hypothetical examples based on internal estimates. They do not constitute a guarantee or promise of specific results. Individual outcomes vary significantly depending on use case, team size, industry, and setup.',
      body: 'One properly structured system can outperform months of random effort.',
      bold: 'BonusClub connects your outreach',
      boldHighlight: 'into one smart flow.',
    },
    audienceSection: {
      label: 'Who This Is For',
      title: 'Not For Everyone.',
      notForTitle: 'Not for:',
      notFor: [
        { title: 'Pre-revenue startups still finding their offer', desc: 'Our system needs existing deal flow to optimize. If you\'re still figuring out what to sell, we\'re not the right partner yet.' },
        { title: 'Teams without anyone in sales', desc: 'We build infrastructure, not replace your team. If nobody picks up the phone, no system in the world will save you.' },
        { title: 'Companies expecting results in 7 days', desc: 'Honest truth: outbound compounds over 30-90 days. If you need revenue tomorrow, this isn\'t the fastest route. We won\'t pretend otherwise.' },
        { title: 'Teams that want magic, not process', desc: 'There\'s no shortcut. If you\'re looking for a button that prints money, we\'re not it. We build systems, and systems need commitment.' },
      ],
      forTitle: 'For:',
      forList: [
        { titleBold: 'B2B service companies', titleLight: 'with proven offers', desc: 'You\'ve closed deals. You know your market. You just need a structured system that fills your calendar without the manual grind.' },
        { titleBold: 'Agencies & consultancies', titleLight: 'scaling past referrals', desc: 'Referrals got you here. But they won\'t get you to predictable growth. We build the outbound engine that comes next.' },
      ],
      bold: 'Discipline scales.',
      boldHighlight: 'Excitement doesn\'t.',
    },
    partnerSection: {
      label: 'Partnership',
      title: 'Become A BonusClub Partner.',
      subtitle: 'We collaborate with selected operators and agencies who want to integrate our outbound infrastructure into their own vertical.',
      youBringTitle: 'You bring:',
      youBring: [
        'Market knowledge',
        'Sales capability',
        'Industry access',
      ],
      weProvideTitle: 'We provide:',
      weProvide: [
        'System blueprint',
        'Infrastructure',
        'Technology',
        'Strategic support',
      ],
      closing: 'Build your own outbound offer, backed by real architecture.',
    },
    founderNote: {
      label: 'Behind The Scenes',
      title: 'Built Under Pressure. Not Theory.',
      lines: [
        'BonusClub was born from solving real outbound problems.',
        'We built the system internally first.',
        'Refined it under performance pressure.',
        'Turned it into infrastructure.',
      ],
      bold: 'No fluff. No hacks. No guru nonsense.',
      closing: 'Just structured acquisition.',
    },
    comparisonSection: {
      label: 'The Difference',
      title: 'Random Outreach vs. Structured Systems.',
      withoutTitle: 'Without Structure',
      withTitle: 'With BonusClub',
      rows: [
        { label: 'Targeting', without: 'Spray & pray', with: 'Precision targeting' },
        { label: 'Messaging', without: 'Generic templates', with: 'Tailored sequences' },
        { label: 'Follow-up', without: 'Forgotten or random', with: 'Automated & consistent' },
        { label: 'Tracking', without: 'Gut feeling', with: 'Live dashboards' },
        { label: 'Scalability', without: 'More people needed', with: 'System-driven' },
        { label: 'Results', without: 'Unpredictable', with: 'Repeatable pipeline' },
      ],
      bold: 'Same effort.',
      boldHighlight: 'Completely different outcome.',
    },
    timelineSection: {
      label: 'Who We Work With',
      title: 'For B2B Companies',
      titleHighlight: 'Ready to Scale.',
      subtitle: 'We are selective about who we partner with. Here is how to determine if there is a fit.',
      negativeHeading: 'Not the right fit if…',
      positiveHeading: 'Who we partner with',
      vsText: 'vs.',
      items: [
        {
          type: 'negative',
          title: 'No Proven Offer Yet',
          text: 'Fewer than 10 closed deals, no documented case studies, or undefined pricing.',
        },
        {
          type: 'negative',
          title: 'Expecting Overnight Results',
          text: 'Outbound compounds over 60 to 90 days. There are no viable shortcuts.',
        },
        {
          type: 'negative',
          title: 'No Internal Sales Capacity',
          text: 'We generate qualified meetings. Your team needs to be ready to close them.',
        },
        {
          type: 'negative',
          title: 'B2C or Low-Value Transactions',
          text: 'Consumer markets and low-ticket products require a different approach.',
        },
        {
          type: 'positive',
          tag: 'SaaS & Tech',
          title: 'Software & Technology Companies',
          text: 'Product-market fit is established. Growth requires a structured pipeline, not more manual effort.',
        },
        {
          type: 'positive',
          tag: 'Agencies & Consultancies',
          title: 'Agencies & Consultancies',
          text: 'Strong reputation, but referrals alone do not scale. Predictable deal flow is the next step.',
        },
        {
          type: 'positive',
          tag: 'Professional Services',
          title: 'Industry-Leading Service Providers',
          text: 'Deal sizes justify outbound investment. The challenge is consistently reaching decision-makers.',
        },
      ],
      bold: 'Does this describe your business?',
      boldHighlight: 'Let\'s connect.',
      cta: 'Request Your Strategy Session',
      ctaSub: 'Limited availability',
    },
    expertSlider: {
      label: 'Your Team',
      title: 'Certified BonusClub Outreach Experts.',
      subtitle: 'Every client gets a dedicated expert, trained, certified, and battle-tested on our system. These are the people behind your pipeline.',
      certified: 'Certified',
      experts: [
        { name: 'Valerie', level: '🇪🇸 Spain', role: 'B2B SaaS Outreach', strengths: ['Copywriting', 'Strategy'], campaigns: '120+ campaigns', stat: '22 avg. meetings/mo', image: './img/valerie.webp' },
        { name: 'Kilian', level: '🇦🇹 Austria', role: 'Agency Growth Specialist', strengths: ['Strategy', 'Technical Setup', 'Management'], campaigns: '85+ campaigns', stat: '18 avg. meetings/mo', image: './img/kilian_3.webp' },
        { name: 'Abdullah', level: '🇹🇷 Turkey', role: 'Technical Specialist', strengths: ['Technical Setup', 'Automation'], campaigns: '60+ campaigns', stat: '15 avg. meetings/mo', image: './img/abdullah.webp' },
        { name: 'Ronja', level: '🇦🇹 Austria', role: 'Multi-Channel Strategist', strengths: ['Copywriting', 'Strategy'], campaigns: '70+ campaigns', stat: '20 avg. meetings/mo', image: './img/ronja_3.webp' },
        { name: 'Marius', level: '🇦🇪 UAE', role: 'Enterprise Outbound Lead', strengths: ['Strategy', 'Outbound Sales'], campaigns: '95+ campaigns', stat: '12 avg. meetings/mo', image: './img/marius_1.webp' },
      ],
      hiring: {
        badge: 'We\'re Hiring',
        title: 'Join Our Team',
        text: 'Become a certified BonusClub Outreach Expert. Work with top clients, sharpen your skills, and grow your career.',
        cta: 'Apply Now',
      },
    },
    trustSection: {
      label: 'Your Data. Your Control.',
      title: 'Privacy by Architecture.',
      subtitle: 'Not a compliance checkbox. A system built from the ground up so your data stays yours. Provably.',
      badges: [
        {
          icon: 'audit',
          title: 'Tamper-Proof Audit Trail',
          desc: 'Every AI decision is logged in an append-only ledger. No edits, no deletions, enforced at database level. Most outreach tools don\'t even log what their AI decides.',
          size: 'wide',
        },
        {
          icon: 'hash',
          title: 'SHA-256 Anonymization',
          desc: 'All analytics run on hashed IDs, not real names. Even if someone accessed the analytics layer, they\'d see timestamps, enums, and hashes. Never a person.',
          size: 'wide',
        },
        {
          icon: 'dsar',
          title: 'DSAR in Seconds',
          tag: 'GDPR Art. 15-17',
          desc: 'When a contact says "delete my data", it\'s done instantly, across analytics, queues, corrections, everywhere. Fully logged and provable.',
          size: 'normal',
        },
        {
          icon: 'human',
          title: 'Human Override',
          desc: 'Your corrections permanently overwrite AI classifications. You can force-send blocked emails with a logged reason. Drafts are held below quality thresholds. The human always wins.',
          size: 'normal',
        },
        {
          icon: 'optout',
          title: 'Global Opt-Out',
          desc: 'One flag stops all channels: email sender, flow engine, warmup, retargeting. Negative replies are auto-flagged. No "oops, it went out anyway."',
          size: 'normal',
        },
        {
          icon: 'score',
          title: 'Pre-Send Scoring',
          desc: 'Every cold email is dual-scored before it leaves: buyer-value and deliverability-risk. No content stored. Only hashes, scores, and reason tags.',
          size: 'normal',
        },
      ],
    },
    sequenceShowcase: {
      agencyLabel: 'Manual Outreach',
      bcLabel: 'BonusClub',
      deadLabel: 'Outreach stops.',
      rows: [
        { day: 'Day 1', agency: { channel: 'email', label: 'Cold Email' },       bc: { channel: 'email', label: 'Cold Email' } },
        { day: 'Day 2', agency: null,                                              bc: { channel: 'linkedin', label: 'Profile Visit' } },
        { day: 'Day 3', agency: { channel: 'email', label: 'Follow-up' },         bc: { channel: 'email', label: 'Follow-up' } },
        { day: 'Day 4', agency: null,                                              bc: { channel: 'linkedin', label: 'Connection Request' } },
        { day: 'Day 5', agency: null,                                              bc: { channel: 'instagram', label: 'Instagram Comment' } },
        { day: 'Day 6', agency: null,                                              bc: { channel: 'linkedin', label: 'LinkedIn DM' } },
        { day: 'Day 7', agency: null,                                              bc: { channel: 'email', label: 'Reply Received ✓', final: true } },
      ],
    },
    manifestoSection: {
      label: 'Our Principles',
      title: 'What We Believe.',
      beliefs: [
        'Structure beats talent without direction.',
        'Outbound is a craft, not a spam tool.',
        'If it can\'t be measured, it doesn\'t exist.',
        'Speed without strategy is just noise.',
        'The best system wins, not the loudest voice.',
        'Discipline compounds. Hype fades.',
        'Real growth is boring. And that\'s the point.',
      ],
      closing: 'These aren\'t slogans. They\'re operating principles.',
    },
    platformShowcase: {
      label: 'Inside The System Layer',
      titleLine1: 'Operating System',
      titleLine2Pre: 'for ',
      titleLine2Highlight: 'Outbound Outreach',
      titleLine2Post: '.',
      subtitle: 'A look inside the outbound engine that delivers qualified meetings for B2B companies.',
      playText: 'Watch Demo',
    },
    headerVideo: {
      title: 'Your Brand Deserves More',
      description: 'Discover how we transform ambitious brands into market leaders with AI-powered sales strategies.',
    },
    useCaseSection: {
      label: 'Use Cases',
      title: 'They Chose BonusClub.',
      titleHighlight: 'Here\'s What Happened.',
      subtitle: 'See how B2B companies transformed their pipeline with structured outbound.',
      before: 'Before',
      after: 'After',
      meetingsUnit: 'meetings / mo',
      within: 'within',
      moreLabel: 'Hear it from them.',
    },
    testimonialSlider: {
      watchVideo: 'Watch video testimonial',
      testimonials: [
        {
          video: './img/caro_1.mp4',
          poster: './img/caro.webp',
          name: 'Carolin K.',
          title: 'Business Coach, Germany',
          quote: 'BonusClub helps me consistently win clients, partners, and new contacts for my network.',
          highlight: 'I used to rely heavily on referrals and social media. Good phases were great, but they were never controllable.',
        },
        {
          video: './img/sarah_1.mp4',
          poster: './img/sarah_1.webp',
          name: 'Sarah R.',
          title: 'Web & Design, Germany',
          quote: 'I was putting out a lot of content, sometimes 3 to 4 posts a week. But revenue was still unpredictable.',
          highlight: 'BonusClub showed me how to reach decision-makers directly, instead of waiting to be discovered.',
        },
      ],
    },
    missionStatement: {
      quote: 'BonusClub helps B2B teams structure, manage, and improve their outreach.',
      subtitle: 'BonusClub is the first AI-Act-compliant, buyer-AI-ready Revenue Control System that enables ambitious B2B teams to run structured multi-channel conversations while protecting domains with iron-clad intelligence and learning from real human (and machine) responses.',
      button: 'Book Strategy Call',
    },
    whatYouGet: {
      label: 'What You Get',
      title: 'Everything You Need Built Into One Platform.',
      subtitle: 'A complete done-for-you outbound system. Built, managed, and optimized by your dedicated BonusClub team.',
      items: [
        { image: './img/connect.webp', title: 'Reach Only <strong>the Right People</strong>', text: 'We don\'t spray and pray. Before a single message goes out, we build a precision-targeted list of the exact companies and decision-makers most likely to convert.', feature: 'Bonusclub ICP Precision Engine' },
        { image: './img/mood.webp', title: '<strong>More Clients</strong> via Multi-Touchpoint Strategy', text: 'Your prospects don\'t live on one channel. We build structured multi-channel sequences so your brand shows up across email, LinkedIn, and retargeting, in the right order, at the right time.', feature: 'Bonusclub Multi-Channel Orchestrator' },
        { image: './img/wake.webp', title: 'Built to <strong>Fill Your Calendar</strong>', text: 'Our system is designed to connect you with qualified decision-makers who match your ICP. When meetings land on your calendar, you show up, have the conversation, and close.', feature: 'Bonusclub Pipeline Autopilot' },
        { image: './img/nomad.webp', title: 'Do It from <strong>Everywhere</strong>', text: 'Beach, airport, home office, it doesn\'t matter. Your entire outbound engine runs in the cloud. Monitor campaigns, review leads, and adjust strategy from anywhere with a single dashboard.', feature: 'Bonusclub Cloud Command Center' },
      ],
      meta: [
        { label: 'Avg. Onboarding', value: '14 days' },
        { label: 'Minimum Commitment', value: '90 days' },
        { label: 'Typical Ramp-Up', value: '30-60 days' },
      ],
      cta: 'Book Your Strategy Call',
    },
    onboardingTimeline: {
      label: 'Agency Services & Done for You',
      title: 'How it works.',
      subtitle: 'Our experts design, build, and launch a custom outreach system tailored to your business, step by step.',
      phases: [
        {
          time: 'Day 1',
          title: 'Setting Up a Strategy',
          text: '2.5h Strategy Brainstorming with 2 Senior Outreach Experts. We define your outcome goals and determine which outreach methods are ideal for your specific use case.',
          details: [
            'Deep-dive into your ICP, offer, and market position',
            'Channel selection and KPI definition tailored to your goals',
          ],
          image: '/img/plan.webp',
        },
        {
          time: 'Day 2-10',
          title: 'Designing Your Outreach System',
          text: 'Your outreach systems get implemented, connected, and coordinated. Every technical layer is built to perform and to scale.',
          details: [
            'Domain warmup, SPF, DKIM & DMARC across all senders',
            'CRM, calendar, and multi-channel sequences fully configured',
          ],
        },
        {
          time: 'Day 11-14',
          title: 'Starting with the First Message',
          text: 'First messages go out. Real prospects see your offer for the first time. We monitor every signal from open rates to reply sentiment.',
          details: [
            'Personalized first-touch sequences go live with A/B tests',
            'Real-time deliverability monitoring from day one',
          ],
          image: '/img/rocket.webp',
        },
        {
          time: 'Week 3-6',
          title: 'Tracking and Optimizing',
          text: 'Data flows in. We double down on what converts, kill what doesn\'t, and scale the winning patterns across channels.',
          details: [
            'Weekly performance reviews and copy iteration',
            'Volume scaling on high-performing sequences',
          ],
        },
        {
          time: 'Month 2+',
          title: 'Scaling Your Outreach System',
          text: 'The system runs at full velocity. Qualified meetings land on your calendar consistently. You focus on closing. We handle the rest.',
          details: [
            'Consistent flow of 4-8+ qualified meetings per month',
            'Continuous optimization: the system gets smarter over time',
          ],
          image: '/img/network.webp',
        },
      ],
      disclaimer: 'This timeline is a general example. Actual timelines vary depending on project scope, complexity, and your specific goals.',
    },
    whyStructuredWins: {
      label: 'The Mechanism',
      title: 'Why Structured Outbound Wins.',
      failTitle: 'Most teams fail because they...',
      failPoints: [
        'Send too randomly, no targeting logic',
        'Stop too early, quit before compounding kicks in',
        'Don\'t track responses, no feedback loop',
        'Don\'t optimize, same mistakes, repeated',
        'Rely on one channel, no redundancy',
      ],
      winTitle: 'We build structure across...',
      winPoints: [
        'Targeting: precision ICP mapping',
        'Messaging: tested, personalized copy',
        'Sequencing: multi-touch, multi-channel',
        'Tracking: every reply, every signal',
        'Optimization: weekly, data-driven',
      ],
      closing: 'Structure creates compounding effects.',
      closingHighlight: 'That\'s the unfair advantage.',
    },
    whyNow: {
      label: 'Outreach is getting more competitive',
      title: 'The Window Is Closing.',
      subtitle: 'A look at your current setup, and why it\'s costing you deals every single week.',
      floatingHeadline: 'Your Deals Are Written In The Stars Because...',
      floatingCards: [
        { title: 'No Structure', text: 'Without a system, every outreach is a gamble.' },
        { title: 'Zero Follow-Up', text: 'Most deals die because nobody followed up on time.' },
        { title: 'Scattered Tools', text: 'Your data lives in 5 different places. Nothing connects.' },
        { title: 'Mass Messages', text: 'Generic outreach gets ignored. Every. Single. Time.' },
        { title: 'No Pipeline', text: 'You don\'t know where your leads are or what\'s next.' },
      ],
      points: [
        { icon: 'fa-solid fa-arrow-trend-up', image: './img/socials.webp', reason: 'Reason 1.', titleCursive: 'Competition', titleClean: 'Is Exploding', text: 'More companies are fighting for the same buyers than ever before. The noise has multiplied over the past few years. Every lead you waste, every deal that slips, a competitor is happy to take it.', source: '' },
        { icon: 'fa-solid fa-clock-rotate-left', image: './img/watch.jpg', reason: 'Reason 2.', titleCursive: 'Repetitive Tasks', titleClean: 'Are Killing Your Sales Time', text: 'Your sales team spends most of the day NOT selling. Digging for info, switching between tools, writing the same messages over and over. That\'s time they should be closing deals.', source: '' },
        { icon: 'fa-solid fa-eye-slash', image: './img/laptop.webp', reason: 'Reason 3.', titleCursive: 'Generic Outreach', titleClean: 'Gets Ignored', text: 'Copy-paste messages don\'t work anymore. People spot mass emails instantly. If your message doesn\'t feel like it was written just for them, it gets deleted without a second thought.', source: '' },
        { icon: 'fa-solid fa-link-slash', image: './img/pipe.webp', reason: 'Reason 4.', titleCursive: 'Your Sales-Pipeline', titleClean: 'Is Leaking Revenue', text: 'The bigger your contact list gets, the more people, conversations, and opportunities fall through the cracks. Without a way to stay on top of every relationship, deals that took months to build quietly disappear.', source: '' },
      ],
      closing: 'Only structured teams win.',
      cta: 'Book Your Strategy Call',
    },
    footer: {
      description: 'BonusClub builds done-for-you outbound systems that deliver qualified B2B meetings. Structure beats chaos.',
      information: 'Information',
      termsOfUse: 'Terms of Use',
      privacyPolicy: 'Privacy Policy',
      legal: 'Legal',
      products: 'Company',
      salesPage: 'How It Works',
      god: '',
      xraay: '',
      mission: 'Our Mission',
      lookingForLogin: 'Looking for the login?',
      logInHere: 'Log in here',
      whatsappCta: 'Text our team on WhatsApp',
      copyright: '© 2026 | All rights reserved by BonusClub LLC',
      tagline: 'Structured outbound. Predictable pipeline.',
    },
    callModal: {
      title: 'Free Strategy Call',
      subtitle: 'Find out how a structured outbound system could work for your business',
      benefit1: 'We analyze your <strong>current pipeline</strong> and <strong>target market</strong>',
      benefit2: 'You get a <strong>clear roadmap</strong> for predictable meetings',
      benefit3: 'We give you an <strong>honest assessment</strong> if we\'re the right fit',
      bookCall: 'Book a Free Call',
      notNow: 'Maybe Later',
    },
    imageHero: {
      salesPage: {
        title: 'GOD Swipe',
        description: 'Your team\'s command center. Orchestrate tasks, align priorities, and execute as one unit, in real time.',
        features: [
          { icon: './img/briefcase.svg', title: 'Task Control', text: 'Every task visible, assignable, and trackable in one swipeable interface.' },
          { icon: './img/live.svg', title: 'Real-Time Sync', text: 'Your team sees exactly what to do next. No Slack threads. No lost context.' },
          { icon: './img/star.svg', title: 'Founder View', text: 'Big picture for leadership, clear next steps for the team. Zero friction.' },
        ],
      },
      god: {
        title: 'GOD',
        description: 'The ultimate AI-powered sales automation platform. Close more deals faster with intelligent insights and automated workflows.',
        features: {
          aiMarketing: {
            title: 'AI Powered Marketing Booster',
            text: 'Generate high-quality customer inquiries through intelligent AI-driven marketing automation.',
          },
          multiTouchpoint: {
            title: 'Multi-Touchpoint Marketing',
            text: 'Reach your dream customers strategically across multiple platforms, synchronized and precise.',
          },
          b2bFocus: {
            title: 'B2B Focus',
            text: 'Targeted outreach to businesses that perfectly match your offering, for maximum success rates.',
          },
          calendlyIntegration: {
            title: 'Calendly Integration',
            text: 'Qualified appointments land automatically in your Calendly, seamlessly and without manual intervention.',
          },
        },
      },
      xraay: {
        title: 'XRAAY',
        description: 'Advanced analytics for your business.',
        features: {
          brandAnalysis: { title: 'Brand Analysis', text: 'Analysis of your brand positioning and market presence.' },
          socialMediaAudit: { title: 'Social Media Audit', text: 'Evaluation of your social media performance.' },
          productLadder: { title: 'Product Ladder', text: 'Strategic product positioning.' },
          predictiveAi: { title: 'Predictive AI', text: 'AI-powered forecasting.' },
        },
      },
    },
    pricingSection: {
      label: 'Pricing',
      title: 'Choose Your Path.',
      subtitle: 'Whether you run it yourself or let us handle everything, BonusClub scales with you.',
      showMore: 'Show all features',
      showLess: 'Show less',
      selfmade: {
        badge: 'Self-Service',
        name: 'BonusClub Selfmade',
        tierLabels: { starter: 'Solo', pro: 'Pro', ultimate: 'Pro Max' },
        starter: {
          description: 'Perfect for solo founders and first outbound tests.',
          price: '$469',
          from: 'from',
          period: '/ month',
          features: [
            '42 Emails / Day',
            'Up to 2 Email Accounts <span class="pricing-feature-light">incl. Warmup Engine</span>',
            'Basic AI Models',
            'AI Tags & Agents',
            'Learning Center Access',
            '220 AI Research Credits included',
          ],
          moreFeatures: [
            'Up to 15,000 Contacts',
            'Domain Warmup & Deliverability Protection',
            'CRM Integration & Pipeline View',
            'Self-Service Dashboard',
            'Community Access',
            '14-Day Money-Back Guarantee',
          ],
        },
        pro: {
          description: 'Built for consistent pipeline growth and sustainable scaling.',
          price: '$629',
          from: 'from',
          period: '/ month',
          features: [
            '120 Emails / Day',
            'Up to 6 Email Accounts <span class="pricing-feature-light">incl. Warmup Engine</span>',
            'Smartest AI Models',
            'AI Tags & Agents',
            'Learning Center Access',
            '660 AI Research Credits included',
          ],
          moreFeatures: [
            'Up to 50,000 Contacts',
            'Domain Warmup & Deliverability Protection',
            'CRM Integration & Pipeline View',
            'A/B Testing & Response Analytics',
            'Template Library & Playbooks',
            '14-Day Money-Back Guarantee',
          ],
        },
        ultimate: {
          description: 'For aggressive scaling and maximum reach.',
          price: '$1,629',
          from: 'from',
          period: '/ month',
          features: [
            '500 Emails / Day',
            'All Pro features included',
            'Full System Depth',
            'AI Tags & Agents',
            'AI Generation Credits included',
            'Up to 250,000 Contacts',
          ],
          moreFeatures: [
            '3,200 AI Spy Credits included',
            'Priority Support',
            'Domain Warmup & Deliverability Protection',
            'Advanced A/B Testing & Analytics',
            'Custom Playbooks & Templates',
            '14-Day Money-Back Guarantee',
          ],
        },
        cta: 'Start Now',
        note: 'You run it. We give you everything to succeed.',
      },
      agency: {
        badge: 'Done-For-You',
        name: 'BonusClub Agency',
        description: 'A dedicated outreach pro builds, runs, and optimizes your entire system. You just show up and close.',
        price: 'On Request',
        period: 'custom scope',
        tagline: 'Your own outreach expert. Powered by BonusClub. You focus on closing.',
        features: [
          '<strong>Dedicated Outreach Pro</strong><span class="pricing-feature-desc">Your personal expert builds & runs it all</span>',
          '<strong>BonusClub Revenue Control System</strong><span class="pricing-feature-desc">The AI operating layer for structured outbound</span>',
          '<strong>Cross-Channel Coordination</strong><span class="pricing-feature-desc">All touchpoints orchestrated as one engine</span>',
          '<strong>Predictive Customer Signals</strong><span class="pricing-feature-desc">Know who\'s ready before they raise their hand</span>',
          '<strong>Qualified Meetings Delivered</strong><span class="pricing-feature-desc">Booked directly on your calendar</span>',
          '<strong>AI-generated copy</strong><span class="pricing-feature-desc">Messages that learn from every reply</span>',
        ],
        moreFeatures: [
          '<strong>Domain Intelligence & Protection</strong><span class="pricing-feature-desc">Iron-clad sender reputation</span>',
          '<strong>Weekly Optimization Cycles</strong><span class="pricing-feature-desc">Data-driven refinements, every week</span>',
          '<strong>Self-Improving AI Loop</strong><span class="pricing-feature-desc">Your corrections make the system smarter</span>',
          'Everything in <strong>Selfmade</strong> included',
        ],
        cta: 'Book Strategy Call',
      },
      footnote: 'No lock-in contracts. All prices in USD, excl. applicable taxes.',
    },
    faq: {
      title: 'Frequently Asked Questions',
      categories: [
        {
          product: 'THE SYSTEM',
          questions: [
            {
              question: 'What exactly is BonusClub?',
              answer: 'It\'s a done-with-you sales system built around one goal: filling your calendar with qualified appointments. Our team of experts handles strategy, setup, and the day-to-day heavy lifting, so you don\'t need any prior experience in sales or tech. You bring the product, we bring the process.',
            },
          ],
        },
        {
          product: 'IDEAL FIT',
          questions: [
            {
              question: 'Who is the system built for, and who should look elsewhere?',
              answer: 'It\'s designed for mid-sized companies with innovative products that genuinely stand out in their market. If your offer solves a real problem and demand already exists, the system turns that potential into booked meetings. It\'s not the right fit if you\'re selling a commodity product available in dozens of variations, simpler tools will serve you better there.',
            },
          ],
        },
        {
          product: 'DONE WITH YOU',
          questions: [
            {
              question: 'Can our internal team learn to run it themselves?',
              answer: 'Absolutely. Besides the fully managed version, we offer a “Done With You” model: our experts build the system alongside your team, train them on the workflows, and stay involved for quality and strategy. Over time, your people operate it independently, with a playbook that actually works.',
            },
          ],
        },
        {
          product: 'HOW IT WORKS',
          questions: [
            {
              question: 'How does BonusClub work under the hood?',
              answer: 'The system connects the touchpoints that matter for your business, email, LinkedIn, or whichever channels your buyers are on, and orchestrates semi-automated follow-ups across them. Every action respects GDPR by design. There\'s no black box: you see what happens, when it happens, and why.',
            },
          ],
        },
        {
          product: 'HUMAN + MACHINE',
          questions: [
            {
              question: 'Does the AI just do whatever it wants?',
              answer: 'Never. The system is built as a partnership between human judgment and machine speed. AI handles the repetitive parts, drafting an email takes roughly two minutes instead of thirty, but nothing goes out without your review and approval. You stay in control at every step. The real value? You get the speed of automation without giving up the quality of a personal touch.',
            },
          ],
        },
        {
          product: 'TIMELINE',
          questions: [
            {
              question: 'How long does it take to get started?',
              answer: 'After a short onboarding phase the system goes live relatively quickly. Outbound is not a light switch, though, it compounds over time. The longer the system runs, the smarter it gets and the better your pipeline becomes. Patience pays off: teams that give the process room to breathe consistently see stronger results than those expecting overnight wins.',
            },
          ],
        },
        {
          product: 'DATA PRIVACY',
          questions: [
            {
              question: 'Is the system GDPR-compliant?',
              answer: 'Yes, by design, not as an afterthought. All data is stored on European servers. The AI only uses publicly available information for research. No automated decisions are made without human oversight, which means the system is fully aligned with GDPR and the EU AI Act. Every action is logged in a tamper-proof audit trail, and contact deletion requests are processed instantly across all layers.',
            },
          ],
        },
        {
          product: 'YOUR MARKETING & BONUSCLUB',
          questions: [
            {
              question: 'How does BonusClub fit with our existing marketing?',
              answer: 'It complements what you already do, it doesn\'t replace it. Every channel for generating new client meetings carries its own strengths and trade-offs, and the right mix always depends on your audience, your market, and where your buyers actually pay attention. Your existing marketing channels and referrals each have their place. BonusClub is designed to complement those efforts, not erase them: it adds a predictable, owned layer of outbound that gives you control over your pipeline instead of leaving growth to chance. The strongest results come when your proven methods and a structured outbound system work in concert.',
            },
          ],
        },
      ],
    },
    pricingPage: {
      label: 'Pricing',
      title: 'Simple, Transparent Pricing.',
      subtitle: 'Every plan includes Hyper-Intelligence, our AI copywriting engine that writes messages so natural, they feel handcrafted. No GPT slop. Ever.',
      hyperBadge: 'Hyper-Intelligence Included',
      hyperDesc: 'Our proprietary AI engine crafts messages that feel genuinely human. Every reply is unique, context-aware, and built to convert, not to sound like a chatbot.',
      plans: [
        {
          name: 'Starter',
          credits: '5,000',
          creditsLabel: 'Credits',
          description: 'For solo founders testing outbound for the first time.',
          features: [
            { icon: 'mail', bold: '42', text: 'emails / day' },
            { icon: 'account', bold: '2', text: 'Email Accounts' },
            { icon: 'warmup', bold: 'Email Warmup', text: 'Engine' },
            { icon: 'compose', bold: 'AI Email Composer', text: '' },
            { icon: 'scan', bold: '1,500', text: 'lead cleans / mo' },
            { icon: 'search', bold: '300', text: 'deep scans / mo' },
          ],
          cta: 'Get Started',
          ctaLink: 'https://bonusclub.link',
        },
        {
          name: 'Pro',
          credits: '20,000',
          creditsLabel: 'Credits',
          popular: true,
          popularLabel: 'Most Popular',
          description: 'Built for consistent pipeline growth and scaling.',
          features: [
            { icon: 'mail', bold: '120', text: 'emails / day' },
            { icon: 'account', bold: '5', text: 'Email Accounts' },
            { icon: 'warmup', bold: 'Email Warmup', text: 'Engine' },
            { icon: 'compose', bold: 'AI Email Composer', text: '' },
            { icon: 'scan', bold: '5,000', text: 'lead cleans / mo' },
            { icon: 'search', bold: '1,000', text: 'deep scans / mo' },
          ],
          cta: 'Get Started',
          ctaLink: 'https://bonusclub.link',
        },
        {
          name: 'Enterprise',
          credits: '100,000',
          creditsLabel: 'Credits',
          description: 'For teams with aggressive scaling targets and maximum reach.',
          features: [
            { icon: 'mail', bold: '420', text: 'emails / day' },
            { icon: 'account', bold: '20', text: 'Email Accounts' },
            { icon: 'warmup', bold: 'Email Warmup', text: 'Engine' },
            { icon: 'compose', bold: 'AI Email Composer', text: '' },
            { icon: 'scan', bold: '50,000', text: 'lead cleans / mo' },
            { icon: 'search', bold: '5,000', text: 'deep scans / mo' },
          ],
          cta: 'Contact Sales',
          ctaLink: 'https://calendly.com/salesgod/scaleup-team-call',
        },
      ],
      moreHint: 'See full feature comparison below',
      footnote: 'All plans billed monthly. No lock-in contracts. Credits refresh every billing cycle.',
      compareTitle: 'Everything Included.',
      compareSubtitle: 'A detailed breakdown of what each plan offers.',
      comparePlans: ['Starter', 'Pro', 'Enterprise'],
      compareCategories: [
        {
          name: 'Communication',
          features: [
            { label: 'Emails per Day', values: ['42', '120', '420'] },
            { label: 'Email Accounts', values: ['2', '5', '20'] },
            { label: 'Email Warmup Engine', values: [true, true, true] },
            { label: 'AI Email Composer', values: [true, true, true] },
            { label: 'Flow Editor', values: [true, true, true] },
            { label: 'Multi-Channel Sequences', values: [false, true, true] },
            { label: 'Custom Send Schedules', values: [false, true, true] },
          ],
        },
        {
          name: 'AI & Intelligence',
          features: [
            { label: 'Hyper-Intelligence Copywriting', values: [true, true, true] },
            { label: 'AI Models', values: ['Basic', 'Smartest', 'Smartest'] },
            { label: 'AI Tags & Agents', values: [true, true, true] },
            { label: 'AI Research Credits', values: ['220', '660', '3,200'] },
            { label: 'Multilanguage Replies', values: [true, true, true] },
            { label: 'AI Email Reply Assistant', values: [true, true, true] },
            { label: 'Self-Improving AI Loop', values: [false, true, true] },
            { label: 'Predictive Customer Signals', values: [false, false, true] },
          ],
        },
        {
          name: 'Data & Research',
          features: [
            { label: 'Lead Cleans per Month', values: ['1,500', '5,000', '50,000'] },
            { label: 'Deep Scans per Month', values: ['300', '1,000', '5,000'] },
            { label: 'Contact Limit', values: ['15,000', '50,000', '250,000'] },
            { label: 'CRM Integration', values: [false, false, true] },
            { label: 'Pipeline View', values: [true, true, true] },
            { label: 'Response Analytics', values: [false, true, true] },
          ],
        },
        {
          name: 'Infrastructure',
          features: [
            { label: 'Domain Warmup & Protection', values: [true, true, true] },
            { label: 'Email Deliverability Checker', values: [true, true, true] },
            { label: 'SPF, DKIM & DMARC Setup', values: [true, true, true] },
            { label: 'Deliverability Monitoring', values: [false, true, true] },
            { label: 'API Access', values: [false, false, true] },
          ],
        },
        {
          name: 'Testing & Optimization',
          features: [
            { label: 'A/B Testing', values: [true, true, true] },
            { label: 'Template Library & Playbooks', values: [false, true, true] },
            { label: 'Custom Playbooks', values: [false, false, true] },
            { label: 'Weekly Optimization Cycles', values: [false, false, true] },
          ],
        },
        {
          name: 'Support & Learning',
          features: [
            { label: 'Academy Access', values: ['Standard', 'Standard', 'Premium'] },
            { label: 'Dedicated Support Group', values: [false, false, true] },
            { label: 'Priority Support', values: [false, false, true] },
            { label: 'Money-Back Guarantee', values: ['14 Days', '14 Days', '14 Days'] },
          ],
        },
      ],
      faqTitle: 'Questions about pricing?',
      faqs: [
        {
          q: 'What are credits?',
          a: 'Credits are the fuel of your BonusClub system. Every action, sending an email, cleaning a lead, or running a deep scan, consumes credits. Your plan determines how many credits you get each month.',
        },
        {
          q: 'What is Hyper-Intelligence?',
          a: 'Hyper-Intelligence is our proprietary AI copywriting layer. Unlike generic AI, it generates messages that read like a real human wrote them, with natural tone, contextual awareness, and zero "GPT slop." It learns from every reply to get smarter over time.',
        },
        {
          q: 'Can I upgrade or downgrade anytime?',
          a: 'Yes. You can switch plans at any time. Upgrades take effect immediately, downgrades apply at the next billing cycle.',
        },
        {
          q: 'What happens when I run out of credits?',
          a: 'You can purchase additional credit packs at any time, or upgrade to a higher plan. Your system pauses sending when credits run out, nothing is lost.',
        },
      ],
    },
    leadCapture: {
      navCta: 'Get Free Access',
      badge: 'Limited Spots Available',
      title: 'Stop Guessing. Start Closing.',
      subtitle: 'Watch how B2B teams use AI-powered outreach to book 3-5x more meetings, without hiring and without the manual grind.',
      formEyebrow: 'Free Strategy Session',
      formTitle: 'Get Your Custom Outreach Plan',
      formDesc: 'See exactly how BonusClub would work for your business. No commitment required.',
      nameLabel: 'Full Name',
      namePlaceholder: 'John Smith',
      emailLabel: 'Work Email',
      emailPlaceholder: 'john@company.com',
      companyLabel: 'Company',
      companyPlaceholder: 'Your company name',
      submitBtn: 'Get My Free Plan',
      formNote: 'No credit card required. Unsubscribe anytime.',
      trustItems: [
        'Personalized outreach strategy',
        'See real results from your industry',
        'Zero obligation, cancel anytime',
      ],
      successTitle: 'You\'re In.',
      successDesc: 'Check your inbox. We\'ll send your custom outreach plan within 24 hours.',
      proofStats: [
        { number: '2,400+', label: 'Meetings Booked' },
        { number: '94%', label: 'Deliverability Rate' },
        { number: '3.2x', label: 'More Pipeline' },
        { number: '<48h', label: 'Time to First Reply' },
      ],
      faqTitle: 'Quick Answers',
      faqs: [
        {
          q: 'Is this really free?',
          a: 'Yes. The strategy session and your custom outreach plan are 100% free. We believe in showing value first, if you see the potential, we can talk about next steps.',
        },
        {
          q: 'How is this different from other outreach tools?',
          a: 'BonusClub isn\'t just a tool, it\'s a system. We combine AI copywriting, multi-channel sequencing, and smart deliverability into one coordinated engine. Most tools give you features. We give you results.',
        },
        {
          q: 'What kind of results can I expect?',
          a: 'Our clients typically see 3-5x more qualified meetings within the first 30 days. The exact results depend on your offer, market, and current setup, which is exactly what we\'ll analyze in your free plan.',
        },
        {
          q: 'How long until I see results?',
          a: 'Most clients book their first meetings within 48 hours of launching their campaigns. Full pipeline acceleration typically happens within 2-4 weeks.',
        },
        {
          q: 'Do I need technical experience?',
          a: 'Not at all. BonusClub handles the technical complexity, from email warmup to deliverability optimization. You focus on closing deals, we handle the system.',
        },
      ],
      faqCta: 'Get Your Free Plan Now',
    },
    partnerCapture: {
      navTag: 'Partners',
      navCta: 'Apply Now',
      badge: 'By Invitation Only',
      title: 'Give Your Agency an Unfair Advantage.',
      subtitle: 'Partner with BonusClub and offer your clients the most powerful AI outreach system on the market, while we send you clients who need hands-on management.',
      formEyebrow: 'Partner Application',
      formTitle: 'Apply to the Partner Program',
      formDesc: 'We\'re selectively onboarding agencies who want to grow with us. Limited spots per market.',
      nameLabel: 'Your Name',
      namePlaceholder: 'John Smith',
      emailLabel: 'Work Email',
      emailPlaceholder: 'john@agency.com',
      agencyLabel: 'Agency Name',
      agencyPlaceholder: 'Your agency name',
      websiteLabel: 'Website',
      websitePlaceholder: 'https://youragency.com',
      clientsLabel: 'Active Clients',
      clientsPlaceholder: 'Select client range',
      clientsOptions: ['1-5 clients', '6-15 clients', '16-30 clients', '30+ clients'],
      submitBtn: 'Submit Application',
      formNote: 'We review applications within 48 hours.',
      trustItems: [
        'Revenue share on every referral',
        'Exclusive partner dashboard',
        'Direct client referrals from BonusClub',
      ],
      successTitle: 'Application Received.',
      successDesc: 'Our partnerships team will review your application and get back to you within 48 hours.',
      valueProps: [
        {
          icon: '💰',
          title: 'Revenue Share',
          desc: 'Earn recurring commission on every client you bring, and every client we send your way.',
        },
        {
          icon: '🔗',
          title: 'Client Referrals',
          desc: 'We refer clients who need hands-on account management directly to certified partners.',
        },
        {
          icon: '⚡',
          title: 'White-Label Ready',
          desc: 'Offer BonusClub under your brand. Your clients see your name, powered by our engine.',
        },
        {
          icon: '🎓',
          title: 'Partner Academy',
          desc: 'Full training, certification, and priority support to make your team unstoppable.',
        },
      ],
      howTitle: 'How the Partnership Works',
      howSubtitle: 'Three steps to turning BonusClub into your agency\'s secret weapon.',
      howSteps: [
        {
          title: 'Apply & Get Certified',
          desc: 'Submit your application. Once approved, complete our partner certification to learn the system inside out.',
        },
        {
          title: 'Onboard & Launch',
          desc: 'Get your white-label dashboard, co-branded materials, and launch your first client campaigns with our support.',
        },
        {
          title: 'Grow & Earn',
          desc: 'Scale your client base, earn revenue share, and receive direct referrals from BonusClub for clients in your market.',
        },
      ],
      proofStats: [
        { number: '120+', label: 'Active Partners' },
        { number: '$2.4M', label: 'Partner Revenue' },
        { number: '340+', label: 'Clients Referred' },
        { number: '97%', label: 'Partner Retention' },
      ],
      faqTitle: 'Partner FAQ',
      faqs: [
        {
          q: 'What does it cost to become a partner?',
          a: 'Nothing. The partner program is free to join. You earn revenue share on clients you bring in, and we refer clients to you at no cost. It\'s a true mutual growth model.',
        },
        {
          q: 'How do client referrals work?',
          a: 'When BonusClub acquires clients who need hands-on campaign management or strategy, we match them with certified partners in their market. You get warm, pre-qualified leads delivered to your inbox.',
        },
        {
          q: 'Can I white-label BonusClub for my agency?',
          a: 'Yes. Certified partners get access to white-label options, your branding, your dashboard, powered by BonusClub\'s infrastructure. Your clients never need to know.',
        },
        {
          q: 'What kind of agencies are you looking for?',
          a: 'We partner with B2B-focused agencies, lead gen, growth marketing, sales consulting, RevOps. If you already serve clients who need pipeline, you\'re a great fit.',
        },
        {
          q: 'How fast can I start earning?',
          a: 'Most partners close their first deal within 2-3 weeks of certification. With our referral pipeline, some partners earn within the first week.',
        },
      ],
      faqCta: 'Apply to Become a Partner',
    },
    auditFunnel: {
      navCta: 'Start Audit',
      introBadge: 'Free · 2 Minutes',
      introTitle: 'How Strong Is Your Outreach?',
      introSubtitle: 'Answer 5 quick questions and get your personalized Outreach Score, plus a custom action plan to fix what\'s broken.',
      startBtn: 'Start My Free Audit',
      introMeta: ['5 Questions', 'Takes 2 min', '1,200+ Audits completed'],
      questionLabel: 'Question',
      backBtn: 'Back',
      questions: [
        {
          question: 'How are you currently generating leads?',
          shortLabel: 'Lead Generation',
          options: [
            { label: 'We rely mostly on referrals and word of mouth', value: 0 },
            { label: 'We rely on inbound and our existing marketing', value: 1 },
            { label: 'We do some manual outreach (email or LinkedIn)', value: 2 },
            { label: 'We have a structured multi-channel outreach system', value: 3 },
          ],
        },
        {
          question: 'What happens after a lead enters your pipeline?',
          shortLabel: 'Follow-up System',
          options: [
            { label: 'We follow up manually when we remember', value: 0 },
            { label: 'We have a basic CRM but no automated sequences', value: 1 },
            { label: 'We use email sequences but they\'re not optimized', value: 2 },
            { label: 'We have automated multi-touch follow-ups with tracking', value: 3 },
          ],
        },
        {
          question: 'How do you handle email deliverability?',
          shortLabel: 'Deliverability',
          options: [
            { label: 'I don\'t know what email deliverability means', value: 0 },
            { label: 'We send from our main domain and hope for the best', value: 1 },
            { label: 'We use separate sending domains but no warmup', value: 2 },
            { label: 'We warm up domains, rotate accounts, and monitor health', value: 3 },
          ],
        },
        {
          question: 'How personalized is your outreach copy?',
          shortLabel: 'Personalization',
          options: [
            { label: 'We send the same message to everyone', value: 0 },
            { label: 'We use basic merge tags (first name, company)', value: 1 },
            { label: 'We segment by industry and customize per segment', value: 2 },
            { label: 'Every message is AI-personalized based on prospect data', value: 3 },
          ],
        },
        {
          question: 'How do you measure outreach performance?',
          shortLabel: 'Analytics',
          options: [
            { label: 'We don\'t track outreach metrics', value: 0 },
            { label: 'We check open rates occasionally', value: 1 },
            { label: 'We track opens, replies, and meetings booked', value: 2 },
            { label: 'We have a full dashboard with A/B tests and revenue attribution', value: 3 },
          ],
        },
      ],
      resultLabel: 'Your Outreach Score',
      verdicts: {
        low: {
          title: 'Critical: Time to Rebuild.',
          desc: 'Your outreach is leaving serious revenue on the table. The good news? Small changes can create massive impact.',
        },
        mid: {
          title: 'Solid Foundation, Big Gaps.',
          desc: 'You have the basics, but you\'re missing the systems that separate good from great. Let\'s fix that.',
        },
        high: {
          title: 'Strong, But There\'s More.',
          desc: 'Your outreach is above average. Now it\'s about optimization and scale to unlock the next level.',
        },
      },
      resultTeaser: [
        'Your detailed score breakdown per category',
        'Custom action plan based on your answers',
        'Industry benchmarks vs. your performance',
      ],
      gateEyebrow: 'Unlock Full Results',
      gateTitle: 'Get Your Custom Report',
      gateDesc: 'Enter your email to unlock your full Outreach Audit, including your personalized action plan.',
      nameLabel: 'Full Name',
      namePlaceholder: 'John Smith',
      emailLabel: 'Work Email',
      emailPlaceholder: 'john@company.com',
      submitBtn: 'Unlock My Report',
      gateNote: 'Free. No spam. Unsubscribe anytime.',
      successTitle: 'Your Report Is Ready.',
      successDesc: 'Here\'s your full Outreach Audit breakdown. Check your inbox for the detailed action plan.',
      successCtaText: 'Want us to fix these gaps for you? Start BonusClub free and automate your entire outreach in under 48 hours.',
      successCtaBtn: 'Start BonusClub Free',
      faqTitle: 'About the Audit',
      faqs: [
        {
          q: 'What do I get from this audit?',
          a: 'You\'ll receive a personalized Outreach Score across 5 key dimensions, plus a custom action plan that tells you exactly what to fix and in what order. It\'s based on the same framework we use with 2,400+ clients.',
        },
        {
          q: 'Is my data shared with anyone?',
          a: 'No. Your answers and email are used solely to generate your report. We don\'t sell data, ever.',
        },
        {
          q: 'How accurate is the score?',
          a: 'The audit is based on patterns we\'ve seen across thousands of B2B outreach systems. While it\'s a self-assessment, it\'s calibrated against real performance data, so it\'s directionally very accurate.',
        },
        {
          q: 'Do I need to buy anything?',
          a: 'No. The audit and your custom action plan are completely free. If you want us to implement the recommendations, you can explore BonusClub, but there\'s zero obligation.',
        },
      ],
    },
    wastedBudget: {
      label: 'The Hidden Cost',
      title: 'Where Your Outreach Budget Really Goes.',
      subtitle: 'Most B2B teams pour time into outreach tools and manual work every month, and barely get any qualified leads in return.',
      quotesTitle: 'Everyone\'s busy.',
      quotesSubtitle: 'Just not with winning new clients.',
      headlines: [
        {
          quote: 'The market is tough right now.',
          name: 'Markus',
          role: 'Head of Sales',
          image: './img/pedro.webp',
        },
        {
          quote: 'We just need more leads.',
          name: 'Verena',
          role: 'Sales Manager',
          image: './img/verena.webp',
        },
        {
          quote: 'It\'s still ramping up.',
          name: 'Sven',
          role: 'Team Lead',
          image: './img/sven.webp',
        },
      ],
      headlinesSubtitle: 'A referral here. A trade show contact there. Sometimes it works... but it was never predictable.',
      companyLabel: 'Your Company',
      invoiceTitle: 'Outreach Invoice, Monthly',
      totalLabel: 'Total Spend',
      totalValue: '$7,660',
      perLeadLabel: 'Cost Per Lead',
      perLeadValue: '$1,915',
      channels: [
        { name: 'AI Credits & APIs', amount: '$1,200/mo', icon: 'ai' },
        { name: 'Sales Rep', amount: '$4,000/mo', icon: 'user' },
        { name: 'Email Outreach Tool', amount: '$160/mo', icon: 'email' },
        { name: 'Sales Navigator', amount: '$80/mo', icon: 'compass' },
        { name: 'Lead Database', amount: '$200/mo', icon: 'database' },
        { name: 'CRM & Automations', amount: '$120/mo', icon: 'gear' },
        { name: 'Content & Copy', amount: '$500/mo', icon: 'pen' },
        { name: 'SDR (Freelancer)', amount: '$1,400/mo', icon: 'user' },
      ],
      resultHeading: 'Lead Result',
      resultValue: '4 Leads',
      progressLabel: 'Pipeline Fill',
      progressPercent: '18%',
      roiLabel: 'Return on Investment',
      roiValue: '-41%',
      bottomLine: 'Typical monthly cost of unstructured outreach, with no clear pipeline.',
    },
  },
  de: {
    navigation: {
      login: 'Erstgespräch buchen',
      startForFree: 'Kostenlos starten',
    },
    countdown: {
      days: 'Tage',
      hours: 'Std',
      minutes: 'Min',
      seconds: 'Sek',
      freeStrategyCall: 'KOSTENLOSER Strategie-Call',
    },
    breakBar: {
      headline: 'Diese Unternehmen vertrauen uns',
    },
    heroHeader: {
      tagline: 'Powered by AI. Controlled by You.',
      taglineDesc: 'Software und Betreuung in einem. Sie bekommen die Termine mit den richtigen Entscheidern, wir machen den Rest.',
      titlePre: 'Ihre individuelle',
      titlePost: 'Maschine.',
      titleWords: ['Kunden', 'Sales', 'Umsatz'],
      subtitle: 'BonusClub verwandelt Outreach in ein strukturiertes System, damit Ihre Pipeline planbar wächst, statt dem Zufall überlassen zu sein.',
      getStarted: 'STRATEGIE-CALL BUCHEN',
      freeBadge: 'KOSTENLOS',
      learnMore: 'So funktioniert es',
      productsTitle: 'Unsere Produkte',
      products: {
        pages: 'PAGES',
        god: 'GOD',
        xraay: 'XRAAY',
      },
    },
    adCostChart: {
      label: 'Warum überhaupt?',
      title: 'Aufmerksamkeit wird immer knapper.',
      subtitle: 'Entscheider werden mit Nachrichten überflutet. Die meisten Teams senden mehr - kaum jemand baut Struktur auf.',
      bars: [
        { year: '2016', ago: '~vor 10 Jahren', cpc: '~25 / Tag', width: '33%', change: 'Baseline' },
        { year: '2021', ago: '~vor 5 Jahren', cpc: '~45 / Tag', width: '58%', change: '+80%' },
        { year: '2025', ago: 'Heute', cpc: '70+ / Tag', width: '92%', change: '+180%' },
      ],
      alert: 'Postfächer sind übersättigt. Ohne Struktur geht Ihre Nachricht im Rauschen unter.',
      source: 'Durchschnittliche Anzahl an Vertriebsnachrichten, die ein B2B-Entscheider pro Tag erhält. Basierend auf öffentlich zugänglichen Branchenbenchmarks.',
    },
    systemHealth: {
      screenTitle: 'system_health.exe',
      indicators: [
        { label: 'Attention', status: 'ok' },
        { label: 'Clicks', status: 'ok' },
        { label: 'Tracking', status: 'critical' },
        { label: 'Intent', status: 'critical' },
        { label: 'Sales Velocity', status: 'critical' },
      ],
      statusOk: 'Online',
      statusCritical: 'Kritisch',
      verdict1: 'Betriebsbereit.',
      verdict2: 'Nicht effizient.',
      footnote: 'Sie bekommen Traffic. Aber Traffic ohne Kaufabsicht ist nur Rauschen.',
    },
    dependencyMeter: {
      label: 'Risikobewertung',
      title: 'Ihre Pipeline gehört Ihnen nicht.',
      gaugeLabel: 'Kanal-Abhängigkeit',
      risks: ['Plattformrisiko', 'Unstetige Ergebnisse', 'Kein echtes Eigentum'],
      costsTitle: 'Wohin Ihr Aufwand wirklich fließt',
      costs: [
        { label: 'Outreach-Tools', value: '$500-2k/Mo' },
        { label: 'Manuelle Arbeit', value: '10-20h/Wo' },
        { label: 'Content-Produktion', value: '$1k-3k/Mo' },
        { label: 'CRM & Tools', value: '$500-2k/Mo' },
        { label: 'SDR-Gehalt', value: '$4k-7k/Mo' },
        { label: 'Verpasste Chancen', value: '????' },
      ],
      footnote: 'Wenn Ihre Pipeline verschwindet, sobald Sie aufhören, haben Sie kein System. Sie haben ein Abo auf Hoffnung.',
    },
    costReceipt: {
      store: 'Manueller Outreach',
      date: 'Q4 2025',
      title: 'So viel kostet unstrukturierter Outreach.',
      lines: [
        { label: 'Versendete E-Mails', value: '4.000', bold: false },
        { label: 'Öffnungsrate', value: '38%', bold: false },
        { label: 'Antworten', value: '52', bold: false },
        { label: 'Antwortrate', value: '1,3%', bold: false },
        { label: 'Positive Antworten', value: '12', bold: false },
        { label: 'Gebuchte Meetings', value: '5', bold: false },
        { label: 'Show-Up-Rate', value: '60%', bold: false },
        { label: 'Gehaltene Meetings', value: '3', bold: false },
        { label: 'Gehalten → Closed', value: '33%', bold: false },
        { label: 'Closed', value: '1', bold: true },
        { label: 'Investierte Stunden', value: '90h', bold: true },
      ],
      totalLabel: 'Investierte Stunden',
      totalValue: '90 Stunden',
      cpcLabel: 'Zeit pro Kunde',
      cpcValue: '90h',
      resultLabel: 'Gewonnene Kunden',
      resultValue: '1',
      footer: 'Danke für Ihren Einsatz. Ergebnisse können variieren. Geduld empfohlen.',
    },
    transitionBreak: {
      line1: 'Eine neue Ära beginnt.',
      line2: 'Überlassen Sie Ihren Umsatz nicht den Sternen.',
    },
    channelNodes: {
      label: 'Das Problem',
      titleHighlight: 'Die meisten Teams',
      titleRest: 'fliegen blind.',
      description: 'Unverbundene Tools, keine Attribution, kein echtes Follow-up. So sieht Outbound ohne Struktur aus.',
      labelAI: 'Die Lösung',
      titleAIHighlight: 'Der "God Modus"',
      titleAIRest: ' wenn',
      titleAIRest2: 'es um Akquise geht.',
      descriptionAI: 'BonusClub koordiniert all Ihre Touchpoints, lernt aus echten Antworten und hilft Ihnen zu skalieren, was funktioniert. Kein Chaos. Kein Rätselraten.',
      toggleOld: '95% aller Unternehmen',
      toggleNew: 'BonusClub',
      stats: [
        { value: '79%', label: 'der Leads konvertieren\nnie zu Sales', source: 'HubSpot State of Marketing, 2024' },
        { value: '42T', label: 'Durchschnittlicher\nB2B-Deal-Zyklus', source: 'Salesforce State of Sales, 2024' },
        { value: '57%', label: 'der Entscheidung fällt\nvor dem Erstkontakt', source: 'Gartner, 2025' },
      ],
      painCards: [
        { icon: 'chart', status: 'critical', title: 'Keine Struktur, keine Pipeline', text: 'Die meisten Teams senden mehr Nachrichten, statt ein System zu bauen. Das Ergebnis: verschwendeter Aufwand, null Planbarkeit.', source: '' },
        { icon: 'clock', status: 'critical', title: 'Deals sterben in Stille', text: 'Ohne strukturiertes Follow-up werden warme Leads kalt. Jede Woche ohne System kostet Sie echten Umsatz.', source: '' },
      ],
      sources: '',
      aiStats: [
        { value: '27+', label: 'Qualifizierte Meetings\nin 60 Tagen*', source: '*Best-Case Kundenbeispiel, keine Garantie' },
        { value: '9', label: 'Neue Partner\npro Quartal*', source: 'Ausgewähltes Kundenbeispiel, nicht garantiert' },
        { value: '24/7', label: 'Always-On\nOutreach-Engine', source: 'Strukturierte Sequenzen & Follow-ups' },
      ],
      aiCards: [
        { icon: 'chart', status: 'active', title: 'Qualifizierte Meetings in Ihrem Kalender', text: 'Unser System ist darauf ausgelegt, gebuchte Termine mit Entscheidern zu liefern, die zu Ihrem ICP passen. Sie erscheinen und closen.' },
        { icon: 'clock', status: 'active', title: 'Strukturiertes Follow-Up das konvertiert', text: 'Multi-Channel-Sequenzen, die jeden Lead im Blick behalten, damit nichts durchs Raster fällt.' },
      ],
      aiSources: '*Diese Zahlen spiegeln ausgewählte Kundenbeispiele wider und sind keine garantierten Ergebnisse. Tatsächliche Ergebnisse variieren erheblich je nach Branche, Markt, Setup und individuellem Einsatz. Vergangene Performance ist kein Indikator für zukünftige Ergebnisse.',
      aiPanelLabel: 'bonusclub.engine',
    },
    chaosWall: {
      items: [
        'Cold Mails → Spam',
        'Tools, die nicht zusammenspielen',
        'Algorithmus-Änderungen',
        '"Ich muss noch überlegen"',
        'No-Shows bei Calls',
        'Content, den keiner sieht',
        'Vanity Metrics',
        'LinkedIn-Spam',
        '0,3% Antwortrate',
        '"Wir melden uns"',
        'Unqualifizierte Leads',
        'Nach Demo geghostet',
        'Posten ins Leere',
        'CRM-Chaos',
        'Zufällige Follow-ups',
        'Aufwand ohne Ergebnis',
        '"Gerade kein guter Zeitpunkt"',
        'Inkonsistente Pipeline',
        'Copy-Paste Outreach',
        'Social Media Burnout',
        'Algorithmen hinterherrennen',
        'Endlose A/B Tests',
        'Lead-Listen, die nirgends hinführen',
        '"Schick mir mal mehr Infos"',
        'Manuelles Prospecting',
      ],
      line1: 'Kommt Ihnen bekannt vor?',
      title: 'Es geht auch anders.',
    },
    processFlow: {
      steps: [
        { label: 'Tiefenanalyse', title: 'Ihr Markt' },
        { label: 'Strukturiertes System', title: 'Gebaut zum Skalieren' },
        { label: 'Planbare Ergebnisse', title: 'Jedes Quartal' },
      ],
    },
    problemSection: {
      label: 'Das Problem',
      title: 'Wachstum fühlt sich zufällig an, weil es das ist.',
      lines: [
        'Sie schalten Kampagnen.',
        'Sie posten Content.',
        'Sie testen Kanäle.',
        'Sie optimieren Messaging.',
      ],
      highlight: 'Manche Wochen laufen. Manche nicht.',
      body: 'Das ist keine Strategie. Das ist Volatilität.',
      conclusion: 'Wenn Ihr Wachstum von Algorithmen, Stimmung oder Timing abhängt, gehört es Ihnen nicht.',
      closing: 'Und was Sie nicht kontrollieren, können Sie nicht skalieren.',
    },
    reframeSection: {
      label: 'Der Perspektivwechsel',
      title: 'Akquise ist Infrastruktur.',
      anti: ['Keine Motivation.', 'Keine Hacks.', 'Kein "einfach mehr machen."'],
      listTitle: 'Infrastruktur bedeutet:',
      list: [
        'Klare Positionierung',
        'Definierte ICP',
        'Strukturiertes Outreach',
        'Messbares Volumen',
        'Kontrollierte Umsetzung',
      ],
      contrast1: 'Kampagnen erzeugen Spitzen.',
      contrast2: 'Systeme erzeugen Konsistenz.',
      bold: 'Hoffnung skaliert nicht.',
      boldHighlight: 'Struktur schon.',
    },
    systemSection: {
      label: 'So funktioniert es',
      title: 'Von null auf qualifizierte Termine.',
      subtitle: 'Ein klarer, wiederholbarer Prozess, damit Ihre Pipeline nie vom Zufall abhängt.',
      steps: [
        { number: '01', title: 'Wir definieren Ihr ICP', text: 'Wer sind Ihre besten Kunden? Wir identifizieren die exakten Unternehmen und Entscheider, die es wert sind, angesprochen zu werden.' },
        { number: '02', title: 'Wir bauen das System', text: 'Multi-Channel-Outreach-Sequenzen, Messaging, technisches Setup. Alles done-for-you.' },
        { number: '03', title: 'Wir liefern Termine', text: 'Qualifizierte, gebuchte Termine mit Entscheidern landen direkt in Ihrem Kalender.' },
        { number: '04', title: 'Wir optimieren wöchentlich', text: 'Echte Daten treiben jede Verbesserung. Was funktioniert wird skaliert. Was nicht, wird gestrichen.' },
      ],
      closing: 'Sie konzentrieren sich aufs Closen. Wir kümmern uns um den Rest.',
      cta: 'Erstgespräch buchen',
    },
    proofSection: {
      label: 'Warum es sich lohnt',
      titleLines: ['Wie viel ist Ihnen', 'ein qualifizierter Termin wert?'],
      subtitle: 'Stellen Sie sich vor, Ihr Vertrieb hat endlich Zeit für die wesentlichen Dinge. Abschlüsse.',
      stats: [
        { value: '~10,5h', unit: '/Tag', description: 'Stunden pro Tag, die potenziell eingespart werden können, wenn durchschnittlich 42 persönlich geschriebene E-Mails durch vorgefertigte und personalisierte Inhalte ersetzt werden.' },
        { prefix: 'Spare', value: '$8.000+', unit: '/Monat', description: 'Potenzielle monatliche Kosteneinsparung, beispielhaft berechnet mit $40 internen Kosten pro Stunde. Tatsächliche Einsparungen hängen von Ihrer spezifischen Situation ab.' },
        { value: '= 210h', unit: '/Monat', description: 'Stunden pro Monat an potenzieller Zeiteinsparung, die nicht mehr für Schreiben, Recherchieren und Nachdenken aufgewendet werden müssen.' },
      ],
      disclaimer: 'Diese Zahlen sind hypothetische Beispiele auf Basis interner Schätzungen. Sie stellen keine Garantie oder Zusicherung konkreter Ergebnisse dar. Individuelle Ergebnisse variieren erheblich je nach Anwendungsfall, Teamgröße, Branche und Setup.',
      body: 'Ein richtig strukturiertes System kann Monate an zufälligem Aufwand übertreffen.',
    },
    audienceSection: {
      label: 'Für wen das ist',
      title: 'Nicht für jeden.',
      notForTitle: 'Nicht für:',
      notFor: [
        { title: 'Pre-Revenue Startups ohne klares Angebot', desc: 'Unser System braucht bestehenden Deal-Flow. Wenn Sie noch herausfinden, was Sie verkaufen wollen, sind wir noch nicht der richtige Partner.' },
        { title: 'Teams ohne jemanden im Vertrieb', desc: 'Wir bauen Infrastruktur, nicht Ihr Team. Wenn niemand ans Telefon geht, hilft kein System der Welt.' },
        { title: 'Unternehmen, die in 7 Tagen Ergebnisse erwarten', desc: 'Ehrlich: Outbound braucht 30-90 Tage zum Compounding. Wenn Sie morgen Umsatz brauchen, ist das nicht der schnellste Weg. Wir erzählen Ihnen nichts anderes.' },
        { title: 'Teams, die Magie wollen statt Prozess', desc: 'Es gibt keine Abkürzung. Wenn Sie einen Knopf suchen, der Geld druckt, sind wir nicht das Richtige. Wir bauen Systeme, und Systeme brauchen Commitment.' },
      ],
      forTitle: 'Für:',
      forList: [
        { titleBold: 'B2B-Dienstleister', titleLight: 'mit bewährtem Angebot', desc: 'Sie haben Deals geclosed. Sie kennen Ihren Markt. Ihnen fehlt nur ein strukturiertes System, das Ihren Kalender füllt, ohne manuellen Grind.' },
        { titleBold: 'Agenturen & Beratungen,', titleLight: 'die über Empfehlungen hinauswachsen', desc: 'Empfehlungen haben Sie hierher gebracht. Aber sie bringen Sie nicht zu planbarem Wachstum. Wir bauen die Outbound-Maschine, die danach kommt.' },
      ],
      bold: 'Disziplin skaliert.',
      boldHighlight: 'Aufregung nicht.',
    },
    partnerSection: {
      label: 'Partnerschaft',
      title: 'Werde BonusClub Partner.',
      subtitle: 'Wir arbeiten mit ausgewählten Partnern und Agenturen zusammen, die unsere Outbound-Infrastruktur in ihre eigene Branche integrieren wollen.',
      youBringTitle: 'Sie bringen:',
      youBring: [
        'Marktwissen',
        'Vertriebsfähigkeit',
        'Branchenzugang',
      ],
      weProvideTitle: 'Wir liefern:',
      weProvide: [
        'System-Blueprint',
        'Infrastruktur',
        'Technologie',
        'Strategische Unterstützung',
      ],
      closing: 'Bauen Sie Ihr eigenes Outbound-Angebot auf, gestützt auf echte Architektur.',
    },
    founderNote: {
      label: 'Hinter den Kulissen',
      title: 'Gebaut unter Druck. Nicht in der Theorie.',
      lines: [
        'BonusClub entstand aus der Lösung realer Outbound-Probleme.',
        'Wir haben das System zuerst intern gebaut.',
        'Unter Performance-Druck verfeinert.',
        'In Infrastruktur verwandelt.',
      ],
      bold: 'Kein Blabla. Keine Hacks. Kein Guru-Unsinn.',
      closing: 'Nur strukturierte Akquise.',
    },
    comparisonSection: {
      label: 'Der Unterschied',
      title: 'Zufälliges Outreach vs. strukturierte Systeme.',
      withoutTitle: 'Ohne Struktur',
      withTitle: 'Mit BonusClub',
      rows: [
        { label: 'Targeting', without: 'Spray & Pray', with: 'Präzises Targeting' },
        { label: 'Messaging', without: 'Generische Templates', with: 'Maßgeschneiderte Sequenzen' },
        { label: 'Follow-up', without: 'Vergessen oder zufällig', with: 'Automatisiert & konstant' },
        { label: 'Tracking', without: 'Bauchgefühl', with: 'Live Dashboards' },
        { label: 'Skalierbarkeit', without: 'Mehr Leute nötig', with: 'System-getrieben' },
        { label: 'Ergebnisse', without: 'Unvorhersehbar', with: 'Wiederholbare Pipeline' },
      ],
      bold: 'Gleicher Aufwand.',
      boldHighlight: 'Komplett anderes Ergebnis.',
    },
    timelineSection: {
      label: 'Mit wem wir arbeiten',
      title: 'Für B2B-Unternehmen',
      titleHighlight: 'die bereit sind zu skalieren.',
      subtitle: 'Wir sind selektiv bei unseren Partnern. So finden Sie heraus, ob es passt.',
      negativeHeading: 'Nicht der richtige Fit, wenn…',
      positiveHeading: 'Mit wem wir zusammenarbeiten',
      vsText: 'vs.',
      items: [
        {
          type: 'negative',
          title: 'Noch kein bewährtes Angebot',
          text: 'Weniger als 10 abgeschlossene Deals, keine dokumentierten Case Studies oder unklares Pricing.',
        },
        {
          type: 'negative',
          title: 'Sofortergebnisse erwartet',
          text: 'Outbound baut sich über 60 bis 90 Tage auf. Es gibt keine sinnvollen Abkürzungen.',
        },
        {
          type: 'negative',
          title: 'Keine interne Sales-Kapazität',
          text: 'Wir generieren qualifizierte Meetings. Ihr Team muss bereit sein, sie zu closen.',
        },
        {
          type: 'negative',
          title: 'B2C oder Low-Value-Transaktionen',
          text: 'Konsumentenmärkte und Low-Ticket-Produkte erfordern einen anderen Ansatz.',
        },
        {
          type: 'positive',
          tag: 'SaaS & Tech',
          title: 'Software & Technologie-Unternehmen',
          text: 'Product-Market-Fit steht. Wachstum erfordert eine strukturierte Pipeline, nicht mehr manuellen Aufwand.',
        },
        {
          type: 'positive',
          tag: 'Agenturen & Beratungen',
          title: 'Agenturen & Beratungen',
          text: 'Starke Reputation, aber Empfehlungen allein skalieren nicht. Planbarer Deal-Flow ist der nächste Schritt.',
        },
        {
          type: 'positive',
          tag: 'Professional Services',
          title: 'Branchenführende Dienstleister',
          text: 'Deal-Sizes rechtfertigen Outbound-Investment. Die Herausforderung ist der konstante Zugang zu Entscheidern.',
        },
      ],
      bold: 'Beschreibt das Ihr Unternehmen?',
      boldHighlight: 'Lassen Sie uns sprechen.',
      cta: 'Strategy Session anfragen',
      ctaSub: 'Begrenzte Verfügbarkeit',
    },
    expertSlider: {
      label: 'Unser System kommt nicht alleine.',
      title: 'Das Team als perfekte Ergänzung.',
      subtitle: 'Monatelang haben unsere Experten unser System praktisch erprobt. Das sind die Menschen hinter Ihrer Pipeline die jeden Tag für neue Termine sorgen.',
      experts: [
        { name: 'Valerie', level: '🇪🇸 Spanien', role: 'B2B SaaS Outreach', strengths: ['Copywriting', 'Strategie'], campaigns: '120+ Kampagnen', stat: 'Ø 22 Meetings/Mo', image: './img/valerie.webp' },
        { name: 'Kilian', level: '🇦🇹 Österreich', role: 'Agency Growth Specialist', strengths: ['Strategie', 'Technical Setup', 'Management'], campaigns: '85+ Kampagnen', stat: 'Ø 18 Meetings/Mo', image: './img/kilian_3.webp' },
        { name: 'Abdullah', level: '🇹🇷 Türkei', role: 'Technical Specialist', strengths: ['Technical Setup', 'Automatisierung'], campaigns: '60+ Kampagnen', stat: 'Ø 15 Meetings/Mo', image: './img/abdullah.webp' },
        { name: 'Ronja', level: '🇦🇹 Österreich', role: 'Multi-Channel Strategist', strengths: ['Copywriting', 'Strategie'], campaigns: '70+ Kampagnen', stat: 'Ø 20 Meetings/Mo', image: './img/ronja_3.webp' },
        { name: 'Marius', level: '🇦🇪 VAE', role: 'Enterprise Outbound Lead', strengths: ['Strategie', 'Outbound Sales'], campaigns: '95+ Kampagnen', stat: 'Ø 12 Meetings/Mo', image: './img/marius_1.webp' },
      ],
      hiring: {
        badge: 'Wir stellen ein',
        title: 'Werden Sie Teil des Teams',
        text: 'Werden Sie zertifizierter BonusClub Outreach Expert. Arbeiten Sie mit Top-Kunden, schärfen Sie Ihre Skills und bringen Sie Ihre Karriere voran.',
        cta: 'Jetzt bewerben',
      },
    },
    trustSection: {
      label: 'Ihre Daten. Ihre Kontrolle.',
      title: 'Privacy by Architecture.',
      subtitle: 'Keine Compliance-Blackbox. Ein System, das von Grund auf so gebaut ist, dass Ihre Daten Ihnen gehören. Nachweisbar.',
      badges: [
        {
          icon: 'audit',
          title: 'Manipulationssicherer Audit Trail',
          desc: 'Jede KI-Entscheidung wird in einem Append-only Ledger geloggt. Kein Bearbeiten, kein Löschen, auf Datenbankebene erzwungen. Die meisten Outreach-Tools loggen nicht mal, was ihre KI entscheidet.',
          size: 'wide',
        },
        {
          icon: 'hash',
          title: 'SHA-256 Anonymisierung',
          desc: 'Alle Analytics laufen auf gehashten IDs, nicht echten Namen. Selbst mit Zugriff auf die Analytics-Schicht sieht man nur Timestamps, Enums und Hashes. Nie eine Person.',
          size: 'wide',
        },
        {
          icon: 'dsar',
          title: 'DSAR in Sekunden',
          tag: 'DSGVO Art. 15-17',
          desc: 'Wenn ein Kontakt sagt "lösch meine Daten", ist es sofort erledigt, über Analytics, Queues, Corrections, überall. Vollständig geloggt und nachweisbar.',
          size: 'normal',
        },
        {
          icon: 'human',
          title: 'Human Override',
          desc: 'Ihre Korrekturen überschreiben KI-Klassifizierungen permanent. Sie können geblockte Emails mit begründetem Override senden. Drafts werden unter Qualitätsschwellen gehalten. Der Mensch gewinnt immer.',
          size: 'normal',
        },
        {
          icon: 'optout',
          title: 'Global Opt-Out',
          desc: 'Ein Flag stoppt alle Kanäle: Email-Sender, Flow-Engine, Warmup, Retargeting. Negative Replies werden automatisch geflaggt. Kein "Ups, die ging trotzdem raus."',
          size: 'normal',
        },
        {
          icon: 'score',
          title: 'Pre-Send Scoring',
          desc: 'Jede Cold Email wird vor dem Versand dual bewertet: Buyer-Value und Deliverability-Risk. Kein Content gespeichert. Nur Hashes, Scores und Reason-Tags.',
          size: 'normal',
        },
      ],
    },
    sequenceShowcase: {
      agencyLabel: 'Manueller Outreach',
      bcLabel: 'BonusClub',
      deadLabel: 'Outreach endet.',
      rows: [
        { day: 'Tag 1', agency: { channel: 'email', label: 'Cold Email' },       bc: { channel: 'email', label: 'Cold Email' } },
        { day: 'Tag 2', agency: null,                                              bc: { channel: 'linkedin', label: 'Profilbesuch' } },
        { day: 'Tag 3', agency: { channel: 'email', label: 'Follow-up' },         bc: { channel: 'email', label: 'Follow-up' } },
        { day: 'Tag 4', agency: null,                                              bc: { channel: 'linkedin', label: 'Connection Request' } },
        { day: 'Tag 5', agency: null,                                              bc: { channel: 'instagram', label: 'Instagram Kommentar' } },
        { day: 'Tag 6', agency: null,                                              bc: { channel: 'linkedin', label: 'LinkedIn DM' } },
        { day: 'Tag 7', agency: null,                                              bc: { channel: 'email', label: 'Reply Received ✓', final: true } },
      ],
    },
    manifestoSection: {
      label: 'Unsere Prinzipien',
      title: 'Woran wir glauben.',
      beliefs: [
        'Struktur schlägt Talent ohne Richtung.',
        'Outbound ist ein Handwerk, kein Spam-Tool.',
        'Was nicht messbar ist, existiert nicht.',
        'Geschwindigkeit ohne Strategie ist nur Lärm.',
        'Das beste System gewinnt, nicht die lauteste Stimme.',
        'Disziplin summiert sich. Hype verblasst.',
        'Echtes Wachstum ist langweilig. Und genau das ist der Punkt.',
      ],
      closing: 'Das sind keine Slogans. Das sind Arbeitsprinzipien.',
    },
    platformShowcase: {
      label: 'UNSER B2B SYSTEM',
      titleHighlightInline: true,
      titleLine1: 'Dieses System bringt ',
      titleLine2Pre: '',
      titleLine2Highlight: 'Neukunden-Termine',
      titleLine2Post: '.',
      subtitle: 'Unsere Experten betreiben das System. Sie bekommen die Termine.',
      playText: 'Demo ansehen',
    },
    headerVideo: {
      title: 'Ihre Marke verdient mehr',
      description: 'Entdecken Sie, wie wir ambitionierte Marken mit KI-gestützten Sales-Strategien zu Marktführern machen.',
    },
    useCaseSection: {
      label: 'Use Cases',
      title: 'Andere machen Outbound...',
      titleHighlight: 'Wir machen Umsatz.',
      subtitle: 'Sehen Sie, wie B2B-Unternehmen ihre Pipeline mit strukturiertem Outbound transformiert haben.',
      before: 'Vorher',
      after: 'Nachher',
      meetingsUnit: 'Meetings / Mo',
      within: 'innerhalb',
      moreLabel: 'Direkt von ihnen.',
    },
    testimonialSlider: {
      watchVideo: 'Video-Testimonial ansehen',
      testimonials: [
        {
          video: './img/caro_1.mp4',
          poster: './img/caro.webp',
          name: 'Carolin K.',
          title: 'Business Coach, Deutschland',
          quote: 'BonusClub hilft mir, konstant Kunden, Partner und neue Kontakte für mein Netzwerk zu gewinnen.',
          highlight: 'Früher war ich stark auf Empfehlungen und Social Media angewiesen. Gute Phasen waren toll, aber nie planbar.',
        },
        {
          video: './img/sarah_1.mp4',
          poster: './img/sarah_1.webp',
          name: 'Sarah R.',
          title: 'Web & Design, Deutschland',
          quote: 'Ich habe viel Content produziert, teilweise 3 bis 4 Posts pro Woche. Aber der Umsatz blieb unberechenbar.',
          highlight: 'BonusClub hat mir gezeigt, wie ich Entscheider direkt erreiche, statt darauf zu warten, entdeckt zu werden.',
        },
      ],
    },
    missionStatement: {
      quote: 'BonusClub hilft B2B-Teams, ihr Outreach zu strukturieren, zu verwalten und zu verbessern.',
      subtitle: 'BonusClub ist das erste AI-Act-konforme, Buyer-AI-fähige Revenue Control System, das ambitionierten B2B-Teams ermöglicht, strukturierte Multi-Channel-Gespräche zu führen, dabei Domains mit eiserner Intelligenz zu schützen und aus echten menschlichen (und maschinellen) Antworten zu lernen.',
      button: 'Strategie-Call buchen',
    },
    whatYouGet: {
      label: 'Was du bekommst',
      title: 'Alles was du brauchst. In einer Plattform.',
      subtitle: 'Ein komplettes Done-for-you Outbound-System. Gebaut, gemanagt und optimiert von deinem dedizierten BonusClub-Team.',
      items: [
        { image: './img/connect.webp', title: 'Erreiche nur <strong>die richtigen Leute</strong>', text: 'Wir streuen nicht blind. Bevor eine einzige Nachricht rausgeht, bauen wir eine präzise Liste der exakten Unternehmen und Entscheider, die am wahrscheinlichsten konvertieren.', feature: 'Bonusclub ICP Precision Engine' },
        { image: './img/mood.webp', title: '<strong>Mehr Kunden</strong> über Multi-Touchpoint-Strategie', text: 'Deine Prospects leben nicht auf einem Kanal. Wir bauen strukturierte Multi-Channel-Sequenzen, damit deine Marke über E-Mail, LinkedIn und Retargeting auftaucht, in der richtigen Reihenfolge, zum richtigen Zeitpunkt.', feature: 'Bonusclub Multi-Channel Orchestrator' },
        { image: './img/wake.webp', title: 'Gebaut um <strong>deinen Kalender zu füllen</strong>', text: 'Unser System ist darauf ausgerichtet, dich mit qualifizierten Entscheidern zu verbinden, die zu deinem ICP passen. Wenn Meetings in deinem Kalender landen, erscheinst du, führst das Gespräch und closet.', feature: 'Bonusclub Pipeline Autopilot' },
        { image: './img/nomad.webp', title: 'Mach es von <strong>überall</strong>', text: 'Strand, Flughafen, Home Office, egal. Deine gesamte Outbound-Engine läuft in der Cloud. Kampagnen monitoren, Leads prüfen und Strategie anpassen, von überall, mit einem einzigen Dashboard.', feature: 'Bonusclub Cloud Command Center' },
      ],
      meta: [
        { label: 'Ø Onboarding', value: '14 Tage' },
        { label: 'Mindestlaufzeit', value: '90 Tage' },
        { label: 'Typischer Ramp-Up', value: '30-60 Tage' },
      ],
      cta: 'Strategie-Call buchen',
    },
    onboardingTimeline: {
      label: 'Agency Services & Done for You',
      title: 'So funktioniert es.',
      subtitle: 'Unsere Experten designen, bauen und launchen ein maßgeschneidertes Outreach-System für Ihr Unternehmen, Schritt für Schritt.',
      phases: [
        {
          time: 'Tag 1',
          title: 'Strategie aufsetzen',
          text: '2,5h Strategie-Brainstorming mit 2 Senior Outreach Experten. Wir definieren Ihre Ziele und bestimmen, welche Outreach-Methoden für Ihren Use Case ideal sind.',
          details: [
            'Deep-Dive in Ihr ICP, Angebot und Marktposition',
            'Kanalauswahl und KPI-Definition auf Ihre Ziele zugeschnitten',
          ],
          image: '/img/plan.webp',
        },
        {
          time: 'Tag 2-10',
          title: 'Dein Outreach-System designen',
          text: 'Deine Outreach-Systeme werden implementiert, verbunden und koordiniert. Jede technische Ebene wird für Performance und Skalierung gebaut.',
          details: [
            'Domain-Warmup, SPF, DKIM & DMARC über alle Sender',
            'CRM, Kalender und Multi-Channel-Sequenzen vollständig konfiguriert',
          ],
        },
        {
          time: 'Tag 11-14',
          title: 'Die erste Nachricht geht raus',
          text: 'Erste Nachrichten gehen raus. Echte Prospects sehen dein Angebot zum ersten Mal. Wir monitoren jedes Signal, von Öffnungsraten bis Reply-Sentiment.',
          details: [
            'Personalisierte First-Touch-Sequenzen gehen live mit A/B-Tests',
            'Echtzeit-Deliverability-Monitoring ab Tag eins',
          ],
          image: '/img/rocket.webp',
        },
        {
          time: 'Woche 3-6',
          title: 'Tracken und optimieren',
          text: 'Daten fließen rein. Wir verdoppeln, was konvertiert, stoppen was nicht funktioniert und skalieren die Gewinner-Patterns über alle Kanäle.',
          details: [
            'Wöchentliche Performance-Reviews und Copy-Iteration',
            'Volumen-Skalierung auf High-Performance-Sequenzen',
          ],
        },
        {
          time: 'Monat 2+',
          title: 'Dein Outreach-System skalieren',
          text: 'Das System läuft auf voller Geschwindigkeit. Qualifizierte Meetings landen konstant in deinem Kalender. Du fokussierst dich aufs Closen. Wir kümmern uns um den Rest.',
          details: [
            'Konstanter Flow von 4-8+ qualifizierten Meetings pro Monat',
            'Kontinuierliche Optimierung: das System wird mit der Zeit smarter',
          ],
          image: '/img/network.webp',
        },
      ],
      disclaimer: 'Diese Timeline ist ein allgemeines Beispiel. Tatsächliche Zeiträume variieren je nach Projektumfang, Komplexität und deinen spezifischen Zielen.',
    },
    whyStructuredWins: {
      label: 'Der Mechanismus',
      title: 'Warum strukturiertes Outbound gewinnt.',
      failTitle: 'Die meisten Teams scheitern, weil sie...',
      failPoints: [
        'Zu zufällig senden, keine Targeting-Logik',
        'Zu früh aufhören, bevor Compounding einsetzt',
        'Antworten nicht tracken, keine Feedback-Schleife',
        'Nicht optimieren, gleiche Fehler, wiederholt',
        'Auf einen Kanal setzen, keine Redundanz',
      ],
      winTitle: 'Wir bauen Struktur über...',
      winPoints: [
        'Targeting: präzises ICP-Mapping',
        'Messaging: getestete, personalisierte Texte',
        'Sequencing: Multi-Touch, Multi-Channel',
        'Tracking: jede Antwort, jedes Signal',
        'Optimierung: wöchentlich, datengetrieben',
      ],
      closing: 'Struktur erzeugt Compound-Effekte.',
      closingHighlight: 'Das ist der unfaire Vorteil.',
    },
    whyNow: {
      label: 'Outreach wird immer kompetitiver',
      title: 'Das Fenster schließt sich.',
      subtitle: 'Ein Blick auf Ihr aktuelles Setup, und warum es Sie jede Woche Deals kostet.',
      floatingHeadline: 'Ihre Deals stehen in den Sternen, weil...',
      floatingCards: [
        { title: 'Keine Struktur', text: 'Ohne System ist jeder Outreach ein Glücksspiel.' },
        { title: 'Kein Follow-Up', text: 'Die meisten Deals sterben, weil niemand rechtzeitig nachgefasst hat.' },
        { title: 'Verstreute Tools', text: 'Ihre Daten liegen in 5 verschiedenen Tools. Nichts ist verbunden.' },
        { title: 'Massen-Nachrichten', text: 'Generischer Outreach wird ignoriert. Jedes. Einzelne. Mal.' },
        { title: 'Keine Pipeline', text: 'Sie wissen nicht, wo Ihre Leads stehen oder was als Nächstes kommt.' },
      ],
      points: [
        { icon: 'fa-solid fa-arrow-trend-up', image: './img/socials.webp', reason: 'Grund 1.', titleCursive: 'Der Wettbewerb', titleClean: 'explodiert', text: 'Mehr Unternehmen als je zuvor kämpfen um dieselben Käufer. Das Rauschen hat sich in den letzten Jahren vervielfacht. Jeder Lead, den Sie verschwenden, jeder Deal, der Ihnen entgeht, ein Wettbewerber nimmt ihn gerne.', source: '' },
        { icon: 'fa-solid fa-clock-rotate-left', image: './img/watch.jpg', reason: 'Grund 2.', titleCursive: 'Repetitive Aufgaben', titleClean: 'fressen Ihre Vertriebszeit', text: 'Ihr Sales-Team verbringt den Großteil des Tages NICHT mit Verkaufen. Infos suchen, zwischen Tools wechseln, die gleichen Nachrichten immer wieder schreiben. Das ist Zeit, in der sie eigentlich Deals closen sollten.', source: '' },
        { icon: 'fa-solid fa-eye-slash', image: './img/laptop.webp', reason: 'Grund 3.', titleCursive: 'Generischer Outreach', titleClean: 'wird ignoriert', text: 'Copy-paste-Nachrichten funktionieren nicht mehr. Leute erkennen Massenmails sofort. Wenn Ihre Nachricht sich nicht anfühlt, als wäre sie genau für sie geschrieben, wird sie gelöscht, ohne einen zweiten Gedanken.', source: '' },
        { icon: 'fa-solid fa-link-slash', image: './img/pipe.webp', reason: 'Grund 4.', titleCursive: 'Ihre Sales-Pipeline', titleClean: 'kostet Sie Umsatz', text: 'Je größer Ihre Kontaktliste wird, desto mehr Leute, Gespräche und Chancen fallen durchs Raster. Ohne eine Möglichkeit, jede Beziehung im Blick zu behalten, verschwinden Deals, die Monate gebraucht haben, still und leise.', source: '' },
      ],
      closing: 'Nur strukturierte Teams gewinnen.',
      cta: 'Strategie-Call buchen',
    },
    footer: {
      description: 'BonusClub baut Done-for-you Outbound-Systeme, die qualifizierte B2B-Meetings liefern.',
      information: 'Informationen',
      termsOfUse: 'Nutzungsbedingungen',
      privacyPolicy: 'Datenschutzerklärung',
      legal: 'Legal',
      products: 'Unternehmen',
      salesPage: 'So funktioniert es',
      god: '',
      xraay: '',
      mission: 'Unsere Mission',
      lookingForLogin: 'Suchen Sie den Login?',
      logInHere: 'Hier anmelden',
      whatsappCta: 'Schreib unserem Team auf WhatsApp',
      copyright: '© 2026 | Alle Rechte vorbehalten bei BonusClub LLC',
      tagline: 'Strukturiertes Outbound. Planbare Pipeline.',
    },
    callModal: {
      title: 'Kostenloser Strategie-Call',
      subtitle: 'Finden Sie heraus, wie ein strukturiertes Outbound-System für Ihr Business funktionieren könnte',
      benefit1: 'Wir analysieren Ihre <strong>aktuelle Pipeline</strong> und Ihren <strong>Zielmarkt</strong>',
      benefit2: 'Sie bekommen eine <strong>klare Roadmap</strong> für planbare Meetings',
      benefit3: 'Wir geben Ihnen eine <strong>ehrliche Einschätzung</strong>, ob wir der richtige Fit sind',
      bookCall: 'Kostenlosen Call buchen',
      notNow: 'Vielleicht später',
    },
    imageHero: {
      salesPage: {
        title: 'GOD Swipe',
        description: 'Die Kommandozentrale deines Teams. Aufgaben orchestrieren, Prioritäten ausrichten und als Einheit ausführen, in Echtzeit.',
        features: [
          { icon: './img/briefcase.svg', title: 'Task Control', text: 'Jede Aufgabe sichtbar, zuweisbar und nachverfolgbar in einem swipebaren Interface.' },
          { icon: './img/live.svg', title: 'Echtzeit-Sync', text: 'Dein Team sieht genau, was als Nächstes zu tun ist. Keine Slack-Threads. Kein verlorener Kontext.' },
          { icon: './img/star.svg', title: 'Founder View', text: 'Das große Ganze für die Führung, klare nächste Schritte fürs Team. Null Reibung.' },
        ],
      },
      god: {
        title: 'GOD',
        description: 'Die ultimative KI-gestützte Sales-Automatisierungsplattform. Schließe mehr Deals schneller mit intelligenten Insights und automatisierten Workflows.',
        features: {
          aiMarketing: {
            title: 'AI Powered Marketing Booster',
            text: 'Generiere hochwertige Kundenanfragen durch intelligente KI-gestützte Marketing-Automatisierung.',
          },
          multiTouchpoint: {
            title: 'Multi-Touchpoint Marketing',
            text: 'Erreiche deine Traumkunden strategisch über mehrere Plattformen hinweg, synchronisiert und präzise.',
          },
          b2bFocus: {
            title: 'B2B Fokus',
            text: 'Gezieltes Outreach an Unternehmen, die perfekt zu deinem Angebot passen, für maximale Erfolgsraten.',
          },
          calendlyIntegration: {
            title: 'Calendly Integration',
            text: 'Qualifizierte Termine landen automatisch in deinem Calendly, nahtlos und ohne manuelle Eingriffe.',
          },
        },
      },
      xraay: {
        title: 'XRAAY',
        description: 'Fortschrittliche Analytics für dein Business.',
        features: {
          brandAnalysis: { title: 'Markenanalyse', text: 'Analyse deiner Markenpositionierung und Marktpräsenz.' },
          socialMediaAudit: { title: 'Social Media Audit', text: 'Bewertung deiner Social-Media-Performance.' },
          productLadder: { title: 'Produkttreppe', text: 'Strategische Produktpositionierung.' },
          predictiveAi: { title: 'Predictive AI', text: 'KI-gestützte Prognosen.' },
        },
      },
    },
    pricingSection: {
      label: 'Pricing',
      title: 'Wähle deinen Weg.',
      subtitle: 'Ob du es selbst steuerst oder uns alles überlässt, BonusClub skaliert mit dir.',
      showMore: 'Alle Features anzeigen',
      showLess: 'Weniger anzeigen',
      selfmade: {
        badge: 'Self-Service',
        name: 'BonusClub Selfmade',
        tierLabels: { starter: 'Solo', pro: 'Pro', ultimate: 'Pro Max' },
        starter: {
          description: 'Perfekt für Einzelunternehmer und erste Outbound-Tests.',
          price: '$469',
          from: 'ab',
          period: '/ Monat',
          features: [
            '42 E-Mails / Tag',
            'Bis zu 2 Email Accounts <span class="pricing-feature-light">incl. Warmup Engine</span>',
            'Basic AI Models',
            'AI Tags & Agents',
            'Learning Center Zugang',
            '220 AI Research Credits inklusive',
          ],
          moreFeatures: [
            'Bis zu 15.000 Kontakte anlegen',
            'Domain-Warmup & Deliverability-Schutz',
            'CRM-Integration & Pipeline-Ansicht',
            'Self-Service Dashboard',
            'Community-Zugang',
            '14 Tage Geld-zurück-Garantie',
          ],
        },
        pro: {
          description: 'Ideal für konstante Pipeline-Entwicklung und nachhaltige Skalierung.',
          price: '$629',
          from: 'ab',
          period: '/ Monat',
          features: [
            '120 E-Mails / Tag',
            'Bis zu 6 Email Accounts <span class="pricing-feature-light">incl. Warmup Engine</span>',
            'Smartest AI Models',
            'AI Tags & Agents',
            'Learning Center Zugang',
            '660 AI Research Credits inklusive',
          ],
          moreFeatures: [
            'Bis zu 50.000 Kontakte anlegen',
            'Domain-Warmup & Deliverability-Schutz',
            'CRM-Integration & Pipeline-Ansicht',
            'A/B-Testing & Antwort-Analytics',
            'Template-Bibliothek & Playbooks',
            '14 Tage Geld-zurück-Garantie',
          ],
        },
        ultimate: {
          description: 'Für aggressive Skalierung und maximale Reichweite.',
          price: '$1,629',
          from: 'ab',
          period: '/ Monat',
          features: [
            '500 E-Mails / Tag',
            'Alle Funktionen vom Pro Account',
            'Volle Systemtiefe',
            'AI Tags & Agents',
            'AI Generation Credits inklusive',
            'Bis zu 250.000 Kontakte anlegen',
          ],
          moreFeatures: [
            '3.200 AI Spy Credits inklusive',
            'Priority Support',
            'Domain-Warmup & Deliverability-Schutz',
            'Erweitertes A/B-Testing & Analytics',
            'Custom Playbooks & Templates',
            '14 Tage Geld-zurück-Garantie',
          ],
        },
        cta: 'Jetzt starten',
        note: 'Du machst es selbst. Wir geben dir alles, um erfolgreich zu sein.',
      },
      agency: {
        badge: 'Done-For-You',
        name: 'BonusClub Agency',
        description: 'Ein dedizierter Outreach-Profi baut, betreibt und optimiert dein gesamtes System. Du musst nur noch closen.',
        price: 'Auf Anfrage',
        period: 'individueller Umfang',
        tagline: 'Dein eigener Outreach-Experte. Mit BonusClub. Du fokussierst dich aufs Closen.',
        features: [
          '<strong>Dedizierter Outreach-Profi</strong><span class="pricing-feature-desc">Dein persönlicher Experte baut & betreibt alles</span>',
          '<strong>BonusClub Revenue Control System</strong><span class="pricing-feature-desc">Der KI-Betriebssystem-Layer für strukturiertes Outbound</span>',
          '<strong>Cross-Channel-Koordination</strong><span class="pricing-feature-desc">Alle Touchpoints als eine Engine orchestriert</span>',
          '<strong>Predictive Customer Signals</strong><span class="pricing-feature-desc">Erkenne, wer bereit ist, bevor sie sich melden</span>',
          '<strong>Qualifizierte Termine geliefert</strong><span class="pricing-feature-desc">Direkt in deinem Kalender gebucht</span>',
          '<strong>KI-unterstützte Texte</strong><span class="pricing-feature-desc">Nachrichten, die aus jeder Antwort lernen</span>',
        ],
        moreFeatures: [
          '<strong>Domain Intelligence & Schutz</strong><span class="pricing-feature-desc">Eiserne Sender-Reputation</span>',
          '<strong>Wöchentliche Optimierungszyklen</strong><span class="pricing-feature-desc">Datengetriebene Verfeinerungen</span>',
          '<strong>Selbstlernende KI-Schleife</strong><span class="pricing-feature-desc">Deine Korrekturen machen das System smarter</span>',
          'Alles aus <strong>Selfmade</strong> inklusive',
        ],
        cta: 'Erstgespräch buchen',
      },
      footnote: 'Keine Knebelverträge. Alle Preise in USD, zzgl. anfallender Steuern.',
    },
    faq: {
      title: 'Häufig gestellte Fragen',
      categories: [
        {
          product: 'DAS SYSTEM',
          questions: [
            {
              question: 'Was genau ist BonusClub?',
              answer: 'Ein Vertriebssystem mit einem klaren Ziel: qualifizierte Termine in Ihren Kalender bringen. Unser Expertenteam übernimmt Strategie, Setup und das operative Tagesgeschäft, Sie brauchen keinerlei Vorerfahrung in Sales oder Technik. Sie bringen das Produkt, wir bringen den Prozess.',
            },
          ],
        },
        {
          product: 'ZIELGRUPPE',
          questions: [
            {
              question: 'Für wen ist das System gemacht, und für wen eher nicht?',
              answer: 'Für mittelständische Unternehmen mit innovativen Produkten, die sich klar vom Markt abheben. Wenn Ihr Angebot ein echtes Problem löst und die Nachfrage bereits da ist, macht das System daraus gebuchte Gespräche. Weniger geeignet ist es bei Commodity-Produkten, die es in dutzenden Varianten schon gibt, dort reichen einfachere Tools.',
            },
          ],
        },
        {
          product: 'DONE WITH YOU',
          questions: [
            {
              question: 'Kann unser internes Team das System selbst bedienen lernen?',
              answer: 'Auf jeden Fall. Neben der vollbetreuten Variante gibt es das „Done With You“-Modell: Unsere Experten bauen das System gemeinsam mit eurem Team auf, schulen die Abläufe und bleiben für Qualität und Strategie an Bord. Schritt für Schritt übernehmt ihr den Betrieb eigenständig, mit einem Playbook, das wirklich funktioniert.',
            },
          ],
        },
        {
          product: 'ABLAUF',
          questions: [
            {
              question: 'Wie funktioniert BonusClub in der Praxis?',
              answer: 'Das System verbindet die Touchpoints, die für euer Business zählen, E-Mail, LinkedIn oder welche Kanäle eure Kunden nutzen, und orchestriert teilautomatisierte Follow-ups über alle hinweg. Jede Aktion ist DSGVO-konform. Es gibt keine Blackbox: Ihr seht, was passiert, wann es passiert und warum.',
            },
          ],
        },
        {
          product: 'MENSCH & MASCHINE',
          questions: [
            {
              question: 'Macht die KI hier einfach, was sie will?',
              answer: 'Niemals. Das System basiert auf dem Zusammenspiel von menschlichem Urteil und maschineller Geschwindigkeit. Die KI übernimmt repetitive Aufgaben, ein E-Mail-Entwurf dauert etwa zwei Minuten statt dreißig, aber nichts wird ohne eure Prüfung und Freigabe verschickt. Ihr behaltet in jedem Schritt die Kontrolle. Der eigentliche Wert? Ihr bekommt das Tempo von Automatisierung, ohne die Qualität einer persönlichen Ansprache aufzugeben.',
            },
          ],
        },
        {
          product: 'ZEITRAHMEN',
          questions: [
            {
              question: 'Wie lange dauert es, bis wir starten können?',
              answer: 'Nach einer kurzen Onboarding-Phase geht das System relativ zügig live. Outbound ist allerdings kein Lichtschalter, es baut sich über die Zeit auf. Je länger das System läuft, desto intelligenter wird es und desto besser wird eure Pipeline. Geduld zahlt sich aus: Teams, die dem Prozess Raum geben, sehen durchweg stärkere Ergebnisse als solche, die sofortige Wunder erwarten.',
            },
          ],
        },
        {
          product: 'DATENSCHUTZ',
          questions: [
            {
              question: 'Ist das System DSGVO-konform?',
              answer: 'Ja, von Grund auf, nicht als nachträglicher Zusatz. Alle Daten liegen auf europäischen Servern. Die KI nutzt ausschließlich öffentlich zugängliche Informationen für die Recherche. Keine automatisierten Entscheidungen ohne menschliche Kontrolle, damit ist das System vollständig konform mit DSGVO und EU AI Act. Jede Aktion wird in einem manipulationssicheren Audit-Trail dokumentiert, und Löschanfragen von Kontakten werden sofort über alle Ebenen hinweg verarbeitet.',
            },
          ],
        },
        {
          product: 'IHR MARKETING & BONUSCLUB',
          questions: [
            {
              question: 'Wie passt BonusClub zu unserem bestehenden Marketing?',
              answer: 'Es ergänzt das, was ihr bereits tut, und ersetzt es nicht. Jede Möglichkeit, Neukundentermine zu generieren, hat ihre eigenen Vor- und Nachteile, und welcher Weg der richtige ist, hängt immer von eurer Zielgruppe, eurem Markt und davon ab, wo eure Kunden tatsächlich erreichbar sind. Euer bestehendes Marketing und Empfehlungen haben alle ihre Berechtigung. BonusClub ist als Ergänzung zu diesen Maßnahmen gedacht, nicht als Ablösung: Es schafft eine planbare, eigene Outbound-Ebene, die euch die Kontrolle über eure Pipeline gibt, statt Wachstum dem Zufall zu überlassen. Die stärksten Ergebnisse entstehen, wenn eure bewährten Methoden und ein strukturiertes Outbound-System Hand in Hand arbeiten.',
            },
          ],
        },
      ],
    },
    pricingPage: {
      label: 'Preise',
      title: 'Einfach. Transparent.',
      subtitle: 'Jeder Plan enthält Hyper-Intelligence, unsere KI-Copywriting-Engine, die Nachrichten schreibt, die sich handgeschrieben anfühlen. Kein GPT-Slop. Nie.',
      hyperBadge: 'Hyper-Intelligence inklusive',
      hyperDesc: 'Unsere proprietäre KI-Engine erstellt Nachrichten, die sich echt menschlich anfühlen. Jede Antwort ist einzigartig, kontextbewusst und auf Conversion gebaut, nicht wie ein Chatbot.',
      plans: [
        {
          name: 'Starter',
          credits: '5.000',
          creditsLabel: 'Credits',
          description: 'Für Solo-Gründer, die Outbound zum ersten Mal testen.',
          features: [
            { icon: 'mail', bold: '42', text: 'E-Mails / Tag' },
            { icon: 'account', bold: '2', text: 'E-Mail Accounts' },
            { icon: 'warmup', bold: 'Email Warmup', text: 'Engine' },
            { icon: 'compose', bold: 'AI Email Composer', text: '' },
            { icon: 'scan', bold: '1.500', text: 'Lead Cleans / Mo' },
            { icon: 'search', bold: '300', text: 'Deep Scans / Mo' },
          ],
          cta: 'Jetzt starten',
          ctaLink: 'https://bonusclub.link',
        },
        {
          name: 'Pro',
          credits: '20.000',
          creditsLabel: 'Credits',
          popular: true,
          popularLabel: 'Beliebteste Wahl',
          description: 'Für konstantes Pipeline-Wachstum und Skalierung.',
          features: [
            { icon: 'mail', bold: '120', text: 'E-Mails / Tag' },
            { icon: 'account', bold: '5', text: 'E-Mail Accounts' },
            { icon: 'warmup', bold: 'Email Warmup', text: 'Engine' },
            { icon: 'compose', bold: 'AI Email Composer', text: '' },
            { icon: 'scan', bold: '5.000', text: 'Lead Cleans / Mo' },
            { icon: 'search', bold: '1.000', text: 'Deep Scans / Mo' },
          ],
          cta: 'Jetzt starten',
          ctaLink: 'https://bonusclub.link',
        },
        {
          name: 'Enterprise',
          credits: '100.000',
          creditsLabel: 'Credits',
          description: 'Für Teams mit aggressiven Skalierungszielen.',
          features: [
            { icon: 'mail', bold: '420', text: 'E-Mails / Tag' },
            { icon: 'account', bold: '20', text: 'E-Mail Accounts' },
            { icon: 'warmup', bold: 'Email Warmup', text: 'Engine' },
            { icon: 'compose', bold: 'AI Email Composer', text: '' },
            { icon: 'scan', bold: '50.000', text: 'Lead Cleans / Mo' },
            { icon: 'search', bold: '5.000', text: 'Deep Scans / Mo' },
          ],
          cta: 'Sales kontaktieren',
          ctaLink: 'https://calendly.com/salesgod/scaleup-team-call',
        },
      ],
      moreHint: 'Alle Features im Vergleich unten',
      footnote: 'Alle Pläne monatlich abgerechnet. Keine Bindung. Credits erneuern sich jeden Abrechnungszyklus.',
      compareTitle: 'Alles inklusive.',
      compareSubtitle: 'Ein detaillierter Überblick über alle Features in jedem Plan.',
      comparePlans: ['Starter', 'Pro', 'Enterprise'],
      compareCategories: [
        {
          name: 'Kommunikation',
          features: [
            { label: 'E-Mails pro Tag', values: ['42', '120', '420'] },
            { label: 'E-Mail Accounts', values: ['2', '5', '20'] },
            { label: 'Email Warmup Engine', values: [true, true, true] },
            { label: 'AI Email Composer', values: [true, true, true] },
            { label: 'Flow Editor', values: [true, true, true] },
            { label: 'Multi-Channel Sequenzen', values: [false, true, true] },
            { label: 'Custom Send Schedules', values: [false, true, true] },
          ],
        },
        {
          name: 'KI & Intelligenz',
          features: [
            { label: 'Hyper-Intelligence Copywriting', values: [true, true, true] },
            { label: 'KI-Modelle', values: ['Basic', 'Smartest', 'Smartest'] },
            { label: 'AI Tags & Agents', values: [true, true, true] },
            { label: 'AI Research Credits', values: ['220', '660', '3.200'] },
            { label: 'Multilanguage Replies', values: [true, true, true] },
            { label: 'AI Email Reply Assistant', values: [true, true, true] },
            { label: 'Selbstlernende KI-Schleife', values: [false, true, true] },
            { label: 'Predictive Customer Signals', values: [false, false, true] },
          ],
        },
        {
          name: 'Daten & Research',
          features: [
            { label: 'Lead Cleans pro Monat', values: ['1.500', '5.000', '50.000'] },
            { label: 'Deep Scans pro Monat', values: ['300', '1.000', '5.000'] },
            { label: 'Kontakt-Limit', values: ['15.000', '50.000', '250.000'] },
            { label: 'CRM Integration', values: [false, false, true] },
            { label: 'Pipeline-Ansicht', values: [true, true, true] },
            { label: 'Response Analytics', values: [false, true, true] },
          ],
        },
        {
          name: 'Infrastruktur',
          features: [
            { label: 'Domain Warmup & Schutz', values: [true, true, true] },
            { label: 'Email Deliverability Checker', values: [true, true, true] },
            { label: 'SPF, DKIM & DMARC Setup', values: [true, true, true] },
            { label: 'Deliverability Monitoring', values: [false, true, true] },
            { label: 'API Access', values: [false, false, true] },
          ],
        },
        {
          name: 'Testing & Optimierung',
          features: [
            { label: 'A/B Testing', values: [true, true, true] },
            { label: 'Template Library & Playbooks', values: [false, true, true] },
            { label: 'Custom Playbooks', values: [false, false, true] },
            { label: 'Wöchentliche Optimierungszyklen', values: [false, false, true] },
          ],
        },
        {
          name: 'Support & Lernen',
          features: [
            { label: 'Academy Zugang', values: ['Standard', 'Standard', 'Premium'] },
            { label: 'Dedizierte Support-Gruppe', values: [false, false, true] },
            { label: 'Priority Support', values: [false, false, true] },
            { label: 'Geld-zurück-Garantie', values: ['14 Tage', '14 Tage', '14 Tage'] },
          ],
        },
      ],
      faqTitle: 'Fragen zu den Preisen?',
      faqs: [
        {
          q: 'Was sind Credits?',
          a: 'Credits sind der Treibstoff deines BonusClub-Systems. Jede Aktion, eine E-Mail senden, einen Lead bereinigen oder einen Deep Scan ausführen, verbraucht Credits. Dein Plan bestimmt, wie viele Credits du monatlich erhältst.',
        },
        {
          q: 'Was ist Hyper-Intelligence?',
          a: 'Hyper-Intelligence ist unsere proprietäre KI-Copywriting-Schicht. Anders als generische KI generiert sie Nachrichten, die sich lesen, als hätte ein echter Mensch sie geschrieben, mit natürlichem Ton, Kontextbewusstsein und null "GPT-Slop." Sie lernt aus jeder Antwort und wird stetig besser.',
        },
        {
          q: 'Kann ich jederzeit upgraden oder downgraden?',
          a: 'Ja. Du kannst jederzeit den Plan wechseln. Upgrades gelten sofort, Downgrades ab dem nächsten Abrechnungszyklus.',
        },
        {
          q: 'Was passiert, wenn meine Credits aufgebraucht sind?',
          a: 'Du kannst jederzeit zusätzliche Credit-Pakete kaufen oder auf einen höheren Plan upgraden. Dein System pausiert den Versand, wenn Credits aufgebraucht sind, nichts geht verloren.',
        },
      ],
    },
    leadCapture: {
      navCta: 'Kostenlos starten',
      badge: 'Begrenzte Plätze verfügbar',
      title: 'Schluss mit Raten. Anfangen zu closen.',
      subtitle: 'Sieh, wie B2B-Teams KI-gestütztes Outreach nutzen, um 3-5x mehr Meetings zu buchen, ohne Hiring und ohne den manuellen Aufwand.',
      formEyebrow: 'Kostenlose Strategie-Session',
      formTitle: 'Dein individueller Outreach-Plan',
      formDesc: 'Sieh genau, wie BonusClub für dein Business funktionieren würde. Ohne Verpflichtung.',
      nameLabel: 'Vollständiger Name',
      namePlaceholder: 'Max Mustermann',
      emailLabel: 'Geschäftliche E-Mail',
      emailPlaceholder: 'max@unternehmen.de',
      companyLabel: 'Unternehmen',
      companyPlaceholder: 'Ihr Unternehmensname',
      submitBtn: 'Meinen Plan erhalten',
      formNote: 'Keine Kreditkarte nötig. Jederzeit abmeldbar.',
      trustItems: [
        'Personalisierte Outreach-Strategie',
        'Echte Ergebnisse aus deiner Branche',
        'Null Verpflichtung, jederzeit kündbar',
      ],
      successTitle: 'Du bist dabei.',
      successDesc: 'Schau in dein Postfach. Wir senden deinen individuellen Outreach-Plan innerhalb von 24 Stunden.',
      proofStats: [
        { number: '2.400+', label: 'Meetings gebucht' },
        { number: '94%', label: 'Zustellrate' },
        { number: '3,2x', label: 'Mehr Pipeline' },
        { number: '<48h', label: 'Bis zur ersten Antwort' },
      ],
      faqTitle: 'Häufige Fragen',
      faqs: [
        {
          q: 'Ist das wirklich kostenlos?',
          a: 'Ja. Die Strategie-Session und dein individueller Outreach-Plan sind 100% kostenlos. Wir glauben daran, zuerst Mehrwert zu zeigen, wenn du das Potenzial siehst, sprechen wir über nächste Schritte.',
        },
        {
          q: 'Wie unterscheidet sich das von anderen Outreach-Tools?',
          a: 'BonusClub ist nicht nur ein Tool, es ist ein System. Wir kombinieren KI-Copywriting, Multi-Channel-Sequenzierung und intelligente Zustellbarkeit in einer koordinierten Engine. Die meisten Tools geben dir Features. Wir geben dir Ergebnisse.',
        },
        {
          q: 'Welche Ergebnisse kann ich erwarten?',
          a: 'Unsere Kunden sehen typischerweise 3-5x mehr qualifizierte Meetings innerhalb der ersten 30 Tage. Die genauen Ergebnisse hängen von deinem Angebot, Markt und aktuellem Setup ab, genau das analysieren wir in deinem kostenlosen Plan.',
        },
        {
          q: 'Wie schnell sehe ich Ergebnisse?',
          a: 'Die meisten Kunden buchen ihre ersten Meetings innerhalb von 48 Stunden nach Kampagnenstart. Volle Pipeline-Beschleunigung passiert typischerweise innerhalb von 2-4 Wochen.',
        },
        {
          q: 'Brauche ich technische Erfahrung?',
          a: 'Überhaupt nicht. BonusClub übernimmt die technische Komplexität, von E-Mail-Warmup bis Zustellbarkeitsoptimierung. Du konzentrierst dich aufs Abschließen, wir kümmern uns um das System.',
        },
      ],
      faqCta: 'Jetzt kostenlosen Plan erhalten',
    },
    partnerCapture: {
      navTag: 'Partner',
      navCta: 'Jetzt bewerben',
      badge: 'Nur auf Einladung',
      title: 'Gib deiner Agentur einen unfairen Vorteil.',
      subtitle: 'Werde BonusClub-Partner und biete deinen Kunden das stärkste KI-Outreach-System am Markt, während wir dir Kunden schicken, die Betreuung brauchen.',
      formEyebrow: 'Partner-Bewerbung',
      formTitle: 'Bewirb dich für das Partner-Programm',
      formDesc: 'Wir onboarden selektiv Agenturen, die mit uns wachsen wollen. Begrenzte Plätze pro Markt.',
      nameLabel: 'Dein Name',
      namePlaceholder: 'Max Mustermann',
      emailLabel: 'Geschäftliche E-Mail',
      emailPlaceholder: 'max@agentur.de',
      agencyLabel: 'Agentur-Name',
      agencyPlaceholder: 'Name deiner Agentur',
      websiteLabel: 'Website',
      websitePlaceholder: 'https://deineagentur.de',
      clientsLabel: 'Aktive Kunden',
      clientsPlaceholder: 'Kundenanzahl wählen',
      clientsOptions: ['1-5 Kunden', '6-15 Kunden', '16-30 Kunden', '30+ Kunden'],
      submitBtn: 'Bewerbung absenden',
      formNote: 'Wir prüfen Bewerbungen innerhalb von 48 Stunden.',
      trustItems: [
        'Revenue Share auf jede Empfehlung',
        'Exklusives Partner-Dashboard',
        'Direkte Kundenempfehlungen von BonusClub',
      ],
      successTitle: 'Bewerbung eingegangen.',
      successDesc: 'Unser Partnerships-Team prüft deine Bewerbung und meldet sich innerhalb von 48 Stunden.',
      valueProps: [
        {
          icon: '💰',
          title: 'Revenue Share',
          desc: 'Verdiene wiederkehrende Provision auf jeden Kunden, den du bringst, und jeden, den wir dir schicken.',
        },
        {
          icon: '🔗',
          title: 'Kunden-Empfehlungen',
          desc: 'Wir vermitteln Kunden, die Hands-on Account Management brauchen, direkt an zertifizierte Partner.',
        },
        {
          icon: '⚡',
          title: 'White-Label Ready',
      desc: 'Biete BonusClub unter deiner Marke an. Deine Kunden sehen deinen Namen, angetrieben von unserer Engine.',
        },
        {
          icon: '🎓',
          title: 'Partner Academy',
          desc: 'Volles Training, Zertifizierung und Priority Support, um dein Team unaufhaltbar zu machen.',
        },
      ],
      howTitle: 'So funktioniert die Partnerschaft',
      howSubtitle: 'Drei Schritte, um BonusClub zur Geheimwaffe deiner Agentur zu machen.',
      howSteps: [
        {
          title: 'Bewerben & Zertifizieren',
          desc: 'Reiche deine Bewerbung ein. Nach Genehmigung absolvierst du unsere Partner-Zertifizierung.',
        },
        {
          title: 'Onboarding & Launch',
          desc: 'Erhalte dein White-Label Dashboard, Co-Branding-Materialien und starte deine ersten Kampagnen mit unserem Support.',
        },
        {
          title: 'Wachsen & Verdienen',
          desc: 'Skaliere deine Kundenbasis, verdiene Revenue Share und erhalte direkte Empfehlungen von BonusClub.',
        },
      ],
      proofStats: [
        { number: '120+', label: 'Aktive Partner' },
        { number: '$2,4M', label: 'Partner-Umsatz' },
        { number: '340+', label: 'Kunden vermittelt' },
        { number: '97%', label: 'Partner-Retention' },
      ],
      faqTitle: 'Partner FAQ',
      faqs: [
        {
          q: 'Was kostet es, Partner zu werden?',
          a: 'Nichts. Das Partnerprogramm ist kostenlos. Du verdienst Revenue Share auf Kunden, die du bringst, und wir vermitteln dir Kunden ohne Kosten. Ein echtes gegenseitiges Wachstumsmodell.',
        },
        {
          q: 'Wie funktionieren Kunden-Empfehlungen?',
          a: 'Wenn BonusClub Kunden gewinnt, die Hands-on Kampagnen-Management oder Strategie brauchen, matchen wir sie mit zertifizierten Partnern in ihrem Markt. Du bekommst warme, vorqualifizierte Leads in dein Postfach.',
        },
        {
          q: 'Kann ich BonusClub white-labeln?',
          a: 'Ja. Zertifizierte Partner erhalten Zugang zu White-Label-Optionen, dein Branding, dein Dashboard, powered by BonusClub-Infrastruktur. Deine Kunden müssen es nie erfahren.',
        },
        {
          q: 'Welche Art von Agenturen sucht ihr?',
          a: 'Wir arbeiten mit B2B-fokussierten Agenturen zusammen, Lead Gen, Growth Marketing, Sales Consulting, RevOps. Wenn du bereits Kunden betreust, die Pipeline brauchen, passt du perfekt.',
        },
        {
          q: 'Wie schnell kann ich verdienen?',
          a: 'Die meisten Partner schließen ihren ersten Deal innerhalb von 2-3 Wochen nach der Zertifizierung ab. Mit unserer Empfehlungs-Pipeline verdienen manche Partner schon in der ersten Woche.',
        },
      ],
      faqCta: 'Jetzt Partner werden',
    },
    auditFunnel: {
      navCta: 'Audit starten',
      introBadge: 'Kostenlos · 2 Minuten',
      introTitle: 'Wie stark ist dein Outreach?',
      introSubtitle: 'Beantworte 5 kurze Fragen und erhalte deinen persönlichen Outreach Score, plus einen individuellen Aktionsplan.',
      startBtn: 'Kostenloses Audit starten',
      introMeta: ['5 Fragen', 'Dauert 2 Min', '1.200+ Audits abgeschlossen'],
      questionLabel: 'Frage',
      backBtn: 'Zurück',
      questions: [
        {
          question: 'Wie generierst du aktuell Leads?',
          shortLabel: 'Lead-Generierung',
          options: [
            { label: 'Hauptsächlich über Empfehlungen und Mundpropaganda', value: 0 },
            { label: 'Wir setzen auf Inbound und unser bestehendes Marketing', value: 1 },
            { label: 'Wir machen manuelles Outreach (E-Mail oder LinkedIn)', value: 2 },
            { label: 'Wir haben ein strukturiertes Multi-Channel-Outreach-System', value: 3 },
          ],
        },
        {
          question: 'Was passiert, nachdem ein Lead in deine Pipeline kommt?',
          shortLabel: 'Follow-up System',
          options: [
            { label: 'Wir folgen manuell nach, wenn wir dran denken', value: 0 },
            { label: 'Wir haben ein einfaches CRM, aber keine automatisierten Sequenzen', value: 1 },
            { label: 'Wir nutzen E-Mail-Sequenzen, aber die sind nicht optimiert', value: 2 },
            { label: 'Wir haben automatisierte Multi-Touch Follow-ups mit Tracking', value: 3 },
          ],
        },
        {
          question: 'Wie gehst du mit E-Mail-Zustellbarkeit um?',
          shortLabel: 'Zustellbarkeit',
          options: [
            { label: 'Ich weiß nicht, was E-Mail-Zustellbarkeit bedeutet', value: 0 },
            { label: 'Wir senden von unserer Hauptdomain und hoffen auf das Beste', value: 1 },
            { label: 'Wir nutzen separate Sendedomains, aber kein Warmup', value: 2 },
            { label: 'Wir warmen Domains auf, rotieren Accounts und überwachen die Health', value: 3 },
          ],
        },
        {
          question: 'Wie personalisiert ist dein Outreach-Text?',
          shortLabel: 'Personalisierung',
          options: [
            { label: 'Wir senden allen die gleiche Nachricht', value: 0 },
            { label: 'Wir nutzen einfache Merge-Tags (Vorname, Firma)', value: 1 },
            { label: 'Wir segmentieren nach Branche und passen pro Segment an', value: 2 },
            { label: 'Jede Nachricht wird KI-personalisiert basierend auf Prospect-Daten', value: 3 },
          ],
        },
        {
          question: 'Wie misst du die Performance deines Outreach?',
          shortLabel: 'Analytics',
          options: [
            { label: 'Wir tracken keine Outreach-Metriken', value: 0 },
            { label: 'Wir prüfen gelegentlich die Öffnungsraten', value: 1 },
            { label: 'Wir tracken Opens, Replies und gebuchte Meetings', value: 2 },
            { label: 'Wir haben ein volles Dashboard mit A/B-Tests und Revenue-Attribution', value: 3 },
          ],
        },
      ],
      resultLabel: 'Dein Outreach Score',
      verdicts: {
        low: {
          title: 'Kritisch: Zeit für den Neuaufbau.',
          desc: 'Dein Outreach lässt ernsthaft Umsatz liegen. Die gute Nachricht? Kleine Änderungen können massiven Impact haben.',
        },
        mid: {
          title: 'Solides Fundament, große Lücken.',
          desc: 'Du hast die Basics, aber dir fehlen die Systeme, die gut von großartig trennen. Lass uns das fixen.',
        },
        high: {
          title: 'Stark, aber da geht mehr.',
          desc: 'Dein Outreach ist überdurchschnittlich. Jetzt geht es um Optimierung und Skalierung fürs nächste Level.',
        },
      },
      resultTeaser: [
        'Dein detaillierter Score-Breakdown pro Kategorie',
        'Individueller Aktionsplan basierend auf deinen Antworten',
        'Branchen-Benchmarks im Vergleich zu deiner Performance',
      ],
      gateEyebrow: 'Volle Ergebnisse freischalten',
      gateTitle: 'Hol dir deinen Report',
      gateDesc: 'Gib deine E-Mail ein, um dein vollständiges Outreach Audit freizuschalten, inklusive personalisierten Aktionsplan.',
      nameLabel: 'Vollständiger Name',
      namePlaceholder: 'Max Mustermann',
      emailLabel: 'Geschäftliche E-Mail',
      emailPlaceholder: 'max@unternehmen.de',
      submitBtn: 'Report freischalten',
      gateNote: 'Kostenlos. Kein Spam. Jederzeit abmeldbar.',
      successTitle: 'Dein Report ist fertig.',
      successDesc: 'Hier ist dein vollständiger Outreach Audit Breakdown. Schau in dein Postfach für den detaillierten Aktionsplan.',
      successCtaText: 'Möchtest du, dass wir diese Lücken für dich schließen? Starte BonusClub kostenlos und automatisiere dein gesamtes Outreach in unter 48 Stunden.',
      successCtaBtn: 'BonusClub kostenlos starten',
      faqTitle: 'Über das Audit',
      faqs: [
        {
          q: 'Was bekomme ich aus diesem Audit?',
          a: 'Du erhältst einen personalisierten Outreach Score über 5 Schlüsseldimensionen, plus einen individuellen Aktionsplan der dir genau sagt, was du in welcher Reihenfolge fixen sollst. Er basiert auf dem gleichen Framework, das wir mit 2.400+ Kunden nutzen.',
        },
        {
          q: 'Werden meine Daten geteilt?',
          a: 'Nein. Deine Antworten und E-Mail werden ausschließlich zur Erstellung deines Reports verwendet. Wir verkaufen keine Daten, niemals.',
        },
        {
          q: 'Wie genau ist der Score?',
          a: 'Das Audit basiert auf Mustern, die wir über tausende B2B-Outreach-Systeme hinweg beobachtet haben. Als Selbsteinschätzung ist es an echten Performance-Daten kalibriert, also richtungsmäßig sehr genau.',
        },
        {
          q: 'Muss ich etwas kaufen?',
          a: 'Nein. Das Audit und dein individueller Aktionsplan sind komplett kostenlos. Wenn du möchtest, dass wir die Empfehlungen umsetzen, kannst du BonusClub erkunden, aber es gibt null Verpflichtung.',
        },
      ],
    },
    wastedBudget: {
      label: 'Kennen Sie das auch?',
      title: 'Wo dein Outreach-Budget wirklich hingeht.',
      subtitle: 'Die meisten B2B-Teams stecken jeden Monat viel Zeit in Outreach-Tools und manuelle Arbeit, und bekommen kaum qualifizierte Leads zurück.',
      quotesTitle: 'Ihr Vertrieb ist beschäftigt.',
      quotesSubtitle: 'Nur nicht damit, neue Kunden zu gewinnen.',
      headlines: [
        {
          quote: 'Der Markt ist gerade schwierig.',
          name: 'Markus',
          role: 'Vertriebsleiter',
          image: './img/pedro.webp',
        },
        {
          quote: 'Wir brauchen einfach mehr Leads.',
          name: 'Verena',
          role: 'Sales Managerin',
          image: './img/verena.webp',
        },
        {
          quote: 'Es fährt noch hoch.',
          name: 'Sven',
          role: 'Team Lead',
          image: './img/sven.webp',
        },
      ],
      headlinesSubtitle: 'Mal eine Empfehlung. Mal ein Messekontakt. Manchmal klappt es... aber planbar war es nie.',
      companyLabel: 'Ihr Unternehmen',
      invoiceTitle: 'Outreach-Rechnung, Monatlich',
      totalLabel: 'Gesamtausgaben',
      totalValue: '$7.660',
      perLeadLabel: 'Kosten pro Lead',
      perLeadValue: '$1.915',
      channels: [
        { name: 'AI Credits & APIs', amount: '$1.200/Mo', icon: 'ai' },
        { name: 'Vertriebsmitarbeiter', amount: '$4.000/Mo', icon: 'user' },
        { name: 'E-Mail Outreach Tool', amount: '$160/Mo', icon: 'email' },
        { name: 'Sales Navigator', amount: '$80/Mo', icon: 'compass' },
        { name: 'Lead-Datenbank', amount: '$200/Mo', icon: 'database' },
        { name: 'CRM & Automations', amount: '$120/Mo', icon: 'gear' },
        { name: 'Content & Copy', amount: '$500/Mo', icon: 'pen' },
        { name: 'SDR (Freelancer)', amount: '$1.400/Mo', icon: 'user' },
      ],
      resultHeading: 'Lead-Ergebnis',
      resultValue: '4 Leads',
      progressLabel: 'Pipeline-Füllung',
      progressPercent: '18%',
      roiLabel: 'Return on Investment',
      roiValue: '-41%',
      bottomLine: 'Typische Monatskosten bei unstrukturiertem Outreach, ohne klare Pipeline.',
    },
  },
};

